import {Component, OnInit} from '@angular/core';
import { FilterPipe } from 'ngx-filter-pipe';
import {DataService} from '../../../Services/data.service';
import { StorageService } from '../../../Services/storage.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ArraySortPipe } from '../../Reports/transaction-reports/orderBy';
import { Title } from '@angular/platform-browser';
import { DateFilterService } from '../../../Services/dateFilter.service';
import { ConfirmDialogService } from '../../../Services/confirm-dialog.service';
import { ResponseModel } from '../../../DataModels/response-model';
import {ChangeDetectorRef} from '@angular/core';
import { BsToastService } from '../../../Services/bs-toast-service';
import {formatDate, ViewportScroller} from '@angular/common';
import { ToWords } from '../../../Services/ToWordsService/ToWords';
import { HttpErrorResponse } from '@angular/common/http';
import {take, switchMap, tap, finalize} from 'rxjs/operators';
import {forkJoin, lastValueFrom, of} from 'rxjs';
import { RoutingTrackerService} from '../../../Services/routing-tracker.service';
import {NavigationService} from '../../../Services/navigation.service';
import {PrintBuilderService} from '../../../Services/print-builder.service';
import {EmailModel} from '../../../DataModels/email-model';
import {CanComponentDeactivate} from '../../../Interfaces/unsaved-changes.interface';
import {PaymentDocumentService} from '../../../Services/payment-document.service';
import {TypeaheadBase} from '../../common/typeahead/typeahead-base';
import {StripePaymentService} from '../../../Services/stripe-payment.service';
import {StripeConnectApService} from '../../../Services/stripe-connect-ap.service';
import {CreateApTransferRequest, GetApPayoutReadinessRequest, ReverseApTransferRequest} from '../../../DataModels/stripe-connect-ap.models';
import {PaymentDraftService} from '../../../Services/payment-draft.service';

// Domain constants for readability and to avoid magic values
const SUBLEDGER_AP = 'ap';
const SUBLEDGER_AR = 'ar';
const BATCH_TYPE_AP = 5;
const BATCH_TYPE_AR = 3;

// PHASE 3 — Single source of truth for payment mode
export enum PaymentMode {
  AR = 'AR',
  AP_CHECK = 'AP_CHECK',
  AP_STRIPE = 'AP_STRIPE',
  AP_OTHER = 'AP_OTHER',
  AR_REFUND = 'AR_REFUND',
  AP_REFUND = 'AP_REFUND'
}

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.css'],
  standalone: false
})
export class PaymentFormComponent extends TypeaheadBase implements OnInit, CanComponentDeactivate {
  // paymentsModel = new PaymentsModel();

  entityTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.entityName, 10);

  vm: any = {};

  today = new Date().toISOString().split('T')[0];
  presetInvoiceId: string | null = null;
  paymentId;
  batchId;
  action;
  rptName = '';
  showDelete;
  isBankLoaded = false;
  type = '';

  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: true,
    email: true,
    print: true,
    saveClose: true,
  };
  showBatches: boolean;
  submitted = false;
  routedFrom = '';
  words = new ToWords();
  invoicesStillNotPaidFound = false;
  testInvoices = [];
  previousPaidInvoices = [];
  batchType: any;
  stripeSetupStatus: 'pending' | 'verified' | null = null;
  stripeSetupStatusMessage = '';
  stripeCancelLoading = false;
  stripeSaveProcessing = false;

  // AP Connect Transfer cancellability — populated after loading an existing AP Stripe payment
  stripeApIsCancellable = false;
  stripeApTransferId = '';

  // Feature flag: opt-in linear Stripe flow orchestrated by service (ensureCustomer → createPaymentIntent)
  // Keep this true to replace the current entangled path without altering UI contracts.
  private useLinearStripeFlow = true;

  buttonsDisabled = false;
  disablePrintButton = false;
  disableEmailButton = false;
  locked = false;
  printed = false;
  // Toolbar button states
  printDisabled = true;
  emailDisabled = true;
  // Prevent accidental double printing of receipt
  private _printingReceipt = false;

  // PHASE 3 — computed payment mode (single source of truth)
  paymentMode: PaymentMode = PaymentMode.AR;

  // Unsaved changes snapshot of the payment document
  originalDocument: any;

  // email
  reportDataToSendInEmail: EmailModel = new EmailModel();
  emailDocumentName = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService,
    private changeDetect: ChangeDetectorRef,
    private vps: ViewportScroller,
    public prevUrl: RoutingTrackerService,
    private paymentDoc: PaymentDocumentService,
    private printBuilder: PrintBuilderService,
    private nav: NavigationService,
    private activatedRoute: ActivatedRoute,
    private stripePaymentService: StripePaymentService,
    private stripeApService: StripeConnectApService,
    private paymentDraft: PaymentDraftService
  ) {
    super();

    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  ngOnInit() {

    this.vm.invoices = [];
    this.vm.paymentType = [];
    this.vm.currency = [];
    this.vm.entity = [];
    this.vm.company = [];
    this.vm.bank = [];
    this.vm.terms = [];
    this.vm.header = [];
    this.vm.item = [];
    // this.vm.entityFilter = {name: ''};
    this.vm.entityFilter = {};
    this.vm.applied = [];
    this.vm.Empty = 0;
    this.vm.printLayout = { checkStock: {} };
    this.vm.company = [];
    this.vm.batches = [];
    this.vm.buttonsDisabled = false;
    this.vm.isLoaded = false;
    this.vm.entityIsLoaded = false;
    this.vm.companyIsLoaded = false;
    this.vm.paymentTypeIsLoaded = false;
    this.vm.currencyIsLoaded = false;
    this.vm.isRefund = false;

    this.buttonsDisabled = false;
    this.disablePrintButton = false;
    this.disableEmailButton = false;

    this.vm.item.batch = false;
    this.vm.item.header = {
      printed: false,
      isLocked: false,
      stripe_customer_id: null,
      stripe_payment_method_id: null,
      stripe_payment_intent_id: null,
      stripe_transaction_id: null,
      stripe_status: null,
      stripe_last_status_utc: null
    };
    this.vm.item.header.company_id = '';
    this.vm.item.header.printed = '';
    this.vm.item.batch = {
      locked: false
    };
    // Ensure detail/applied arrays exist early so template bindings like detail[0].amount are safe
    if (!Array.isArray(this.vm.item.detail)) {
      this.vm.item.detail = [{id: 1, amount: ''}];
    }
    if (!Array.isArray(this.vm.applied)) {
      this.vm.applied = [];
    }
    if (!Array.isArray(this.vm.item.applied)) {
      this.vm.item.applied = this.vm.applied;
    }
    // this.vm.item.batch.locked = false;
    this.route.queryParamMap.subscribe(async (params: ParamMap) => {
      this.paymentId = params.get('paymentId');
      this.batchId = params.get('batchId');
      this.action = params.get('action');
      const presetEntityId = params.get('entity_id');
      this.presetInvoiceId = params.get('invoice_id');

      // console.log('loading lookups');
      await this.loadLookups().then();
      // console.log('back from loading lookups');

      if (this.paymentId !== 'newAP' && this.paymentId !== 'newAR') {
        this.getPaymentEditData();
      } else {
        this.init().then(async () => {
          // Default payable type selection to AP for new documents
          this.vm.payableType = 'ap';
          this.onPayableTypeChange('ap');
          // Pre-populate entity if entity_id was passed as a query param
          if (presetEntityId) {
            const match = (this.vm.entity || []).find((e: any) => String(e.id) === String(presetEntityId));
            if (match) {
              this.vm.item.header.entityInput = match.name;
              await this.onEntityInputChange(match.name);
            }
            // Check for a multi-invoice draft from PaymentDraftService
            const draft = this.paymentDraft.consume();
            if (draft && draft.invoices && draft.invoices.length > 0) {
              this.vm.invoices = draft.invoices.map((inv: any) => ({
                ...inv,
                applied_amount: Math.round(Math.max(0, Number(inv.detail_total || 0) - Number(inv.payment_applied_total || 0)) * 100) / 100
              }));
              this.reverseHeaderAmount();
              this.calcTotals();
            } else if (this.presetInvoiceId) {
              // Fall back to single-invoice query param flow
              this.getInvoicesEntity();
            }
          }
          this.captureOriginalSnapshot();
          try {
            this.updateHeaderButtonStates();
          } catch {
          }
          // In case defaults or user selections indicate Stripe, attempt one fetch
          this.loadStripeSetupForEntityIfStripeType();
        });
      }
    });
  }

  isFieldEmpty(value: any): boolean {
    let retVal = false;
    if (!value) {
      retVal = true;
    } else {
      retVal = false;
    }
    return retVal;
  }

  isLocked(): boolean {
    if (this.vm.item.batch.locked !== undefined) {
      return !!(this.vm.item.batch.locked || this.vm.header.printed);
   }
  }

  isPrinted(): boolean {
    if (this.vm.item.header.printed !== undefined) {
      return this.vm.item.header.printed;
    }
  }

  // Build a minimal snapshot of the editable document (include current UI fields as the user sees them)
  buildSnapshot(sourceItem?: any): any {
    try {
      const item = sourceItem ?? (this.vm?.item || {});
      const clonedItem = typeof structuredClone === 'function'
        ? structuredClone(item)
        : JSON.parse(JSON.stringify(item));
      const normalizeKey = (value: any): string => {
        if (value === undefined || value === null) {
          return '';
        }
        return String(value);
      };
      const sortByKey = (arr: any[], keyBuilder: (row: any) => string): any[] =>
        arr
          .map((row: any) => ({...(row || {})}))
          .sort((a: any, b: any) => keyBuilder(a).localeCompare(keyBuilder(b)));
      const detailKey = (row: any): string => [
        row?.id,
        row?.detail_id,
        row?.account_id,
        row?.item_id,
        row?.description,
        row?.amount,
        row?.debit_credit
      ].map(normalizeKey).join('|');
      const appliedKey = (row: any): string => [
        row?.applied_header_id,
        row?.header_id,
        row?.id,
        row?.number,
        row?.applied_amount,
        row?.applied_date
      ].map(normalizeKey).join('|');
      if (Array.isArray(clonedItem.detail)) {
        clonedItem.detail = sortByKey(clonedItem.detail, detailKey);
      }
      if (Array.isArray(clonedItem.applied)) {
        clonedItem.applied = sortByKey(clonedItem.applied, appliedKey);
      }
      if (clonedItem?.header) {
        if (clonedItem.header.header_date) {
          try {
            clonedItem.header.header_date = this.dateFilter.GetDateFormat(clonedItem.header.header_date);
          } catch {
          }
        }
        const batchType = String(clonedItem?.batch?.type_id || '').trim();
        if (batchType === String(BATCH_TYPE_AR)) {
          const num = Number(clonedItem.header.detail_total);
          if (Number.isFinite(num)) {
            clonedItem.header.detail_total = Math.abs(num);
          }
        }
        if (!clonedItem.header.entityInput && clonedItem.header.entity_id) {
          const entityMatch = (this.vm?.entity || []).find((e: any) => e && e.id === clonedItem.header.entity_id);
          if (entityMatch?.name) {
            clonedItem.header.entityInput = entityMatch.name;
          }
        }
        if (!clonedItem.header.bank_id && Array.isArray(this.vm?.bank) && this.vm.bank.length === 1) {
          clonedItem.header.bank_id = this.vm.bank[0]?.id;
        }
        if (!clonedItem.header.company_id && Array.isArray(this.vm?.company) && this.vm.company.length === 1) {
          clonedItem.header.company_id = this.vm.company[0]?.id;
        }
        if (!clonedItem.header.currency_id && Array.isArray(this.vm?.currency) && this.vm.currency.length === 1) {
          clonedItem.header.currency_id = this.vm.currency[0]?.id;
        }
        if (!clonedItem.header.payment_type_id && Array.isArray(this.vm?.paymentType) && this.vm.paymentType.length === 1) {
          clonedItem.header.payment_type_id = this.vm.paymentType[0]?.id;
        }
      }
      if (Array.isArray(clonedItem.applied)) {
        clonedItem.applied = clonedItem.applied.map((row: any) => {
          const next = {...(row || {})};
          delete next.payment_applied_total;
          return next;
        });
      }
      // Keep entityInput so changes in the entity text box are also treated as edits
      // Normalize invoices list to a stable, minimal signature so fetching/adding invoices triggers unsaved-change
      const invoicesIds = Array.isArray(this.vm?.invoices)
        ? this.vm.invoices
          .map((inv: any) => (inv && (inv.id ?? inv.header_id ?? inv.detail_id)))
          .filter((id: any) => id !== undefined && id !== null && id !== '')
          .map((id: any) => String(id))
          .sort()
        : [];
      return {
        ...clonedItem,
        invoicesIds
      };
    } catch {
      return {};
    }
  }

  // Compare the current snapshot to the original to determine if there are unsaved changes
  hasChanges(): boolean {
    try {
      if (!this.originalDocument) {
        return false;
      }
      const current = this.buildSnapshot();
      const original = this.originalDocument;
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  // Helper: build query string for entry/invoices and entry endpoints
  // Includes applied_only flag to request only refundable (already-applied) invoices when in refund mode.
  private buildEntryQueryParams(
    entityId: any,
    companyId: any,
    dateValue: any,
    subLedger: string,
    includeCreditMemos: string,
    appliedOnly: boolean = false
  ): string {
    const params = new URLSearchParams();
    params.set('entity_id', entityId ? String(entityId) : '');
    params.set('company_id', companyId ? String(companyId) : '');
    params.set('toDate', dateValue ? String(dateValue) : '');
    params.set('batch_type_id_in', subLedger === SUBLEDGER_AP ? '4' : '2');
    params.set('credit_memos_only', String(includeCreditMemos));
    // New requirement: always include applied_only, true when creating a refund, false otherwise
    params.set('applied_only', String(!!appliedOnly));

    return params.toString();
  }

  // Helper: build query string for entity address fetch
  private buildAddressesQueryParams(entityId: any): string {
    const params = new URLSearchParams();
    params.set('billing_address', '1');
    params.set('entity_id', entityId ? String(entityId) : '');
    return params.toString();
  }

  // Helper: build query string for invoice re-check (include payment_id, empty toDate)
  private buildEntryInvoicesCheckParams(
    entityId: any,
    companyId: any,
    subLedger: string,
    paymentId: any,
    dateValue: any,
    includeCreditMemos: false,
    appliedOnly: false
  ): string {
    const params = new URLSearchParams();
    params.set('entity_id', entityId ? String(entityId) : '');
    params.set('company_id', companyId ? String(companyId) : '');
    params.set('toDate', dateValue ? String(dateValue) : '');
    params.set('batch_type_id_in', subLedger === SUBLEDGER_AP ? '4' : '2');
    params.set('payment_id', paymentId ? String(paymentId) : '');
    params.set('credit_memos_only', String(includeCreditMemos));
    params.set('applied_only', String(!!appliedOnly));
    return params.toString();
  }

  // private buildEntryQueryParams(
  //   entityId: any,
  //   companyId: any,
  //   dateValue: any,
  //   subLedger: string,
  //   includeCreditMemos: string,
  //   appliedOnly: boolean = false
  // ): string {
  //   const params = new URLSearchParams();
  //   params.set('entity_id', entityId ? String(entityId) : '');
  //   params.set('company_id', companyId ? String(companyId) : '');
  //   params.set('toDate', dateValue ? String(dateValue) : '');
  //   params.set('batch_type_id_in', subLedger === SUBLEDGER_AP ? '4' : '2');
  //   params.set('credit_memos_only', String(includeCreditMemos));
  //   // New requirement: always include applied_only, true when creating a refund, false otherwise
  //   params.set('applied_only', String(!!appliedOnly));
  //
  //   return params.toString();
  // }

  init() {
    return new Promise<void>((resolve) => {
      // this.vm.isLoaded = false;
      this.submitted = false;
      if (this.paymentId === 'newAP' || this.paymentId === 'newAR') {
        // NEW ENTRY
        this.vm.item = {};
        this.vm.item.batch = {};
        this.vm.item.batch.description = $localize`:Payment Batch @@paymentBatch:Payment Batch`;
        this.vm.item.header = {
          locked: false,
          currencyRate: '1',
          header_date: new Date(),
          stripe_customer_id: null,
          stripe_payment_method_id: null,
          stripe_payment_intent_id: null,
          stripe_transaction_id: null,
          stripe_status: null,
          stripe_last_status_utc: null
        };
        // For new entries, allow UI-driven auto-fill until the user edits the Amount
        this.vm.manualAmount = false;
        // this.vm.item.header.locked = false;
        // this.vm.item.header.currency_rate = '1';
        // this.vm.item.header.header_date = new Date();
        this.vm.item.detail = [{id: 1, amount: ''}];
        this.vm.applied = this.vm.item.applied = [];
        if (this.vm.bank.length === 1) {
          this.vm.item.detail[0].account_id = this.vm.bank[0].account_id;
        }
        if (this.paymentId === 'newAP') {
          this.vm.item.batch.type_id = String(BATCH_TYPE_AP);
          this.vm.subLedger = SUBLEDGER_AP;
          this.vm.paymentTypeName = $localize`:Payable @@payable:Payable`;
          this.titleService.setTitle($localize`:Payable @@payable:Payable`);
          this.rptName = 'Payable';
          // Initialize payable type selection for AP
          this.vm.payableType = 'ap';
        } else {
          this.vm.item.batch.type_id = String(BATCH_TYPE_AR);
          this.vm.subLedger = SUBLEDGER_AR;
          this.vm.paymentTypeName = $localize`:Receivable @@receivable:Receivable`;
          this.titleService.setTitle($localize`:Receivable @@receivable:Receivable`);
          this.rptName = 'Receivable';
          // For AR context, payable type selector is irrelevant
          this.vm.payableType = 'ap';
        }
        if (this.batchId) {
          this.vm.batchId = this.vm.item.batch.id = this.batchId;
        } else {
          this.vm.item.batch.description = 'Batch';
        }
        this.spliceEntities();
        if (this.vm.Preferences.default_company_id) {
          this.vm.item.header.company_id = this.vm.Preferences.default_company_id;
        }
        resolve();
      } else {
        // EDIT ENTRY
        // For edits, ensure manual amount so auto-fill won't overwrite the stored amount
        // this.vm.manualAmount = true;
        this.vm.isRefund = false;
        if (Number(this.vm.item.batch.type_id) === BATCH_TYPE_AR) {
          this.vm.subLedger = SUBLEDGER_AR;
          this.vm.paymentTypeName = $localize`:Receivable @@receivable:Receivable`;
          this.titleService.setTitle(
            $localize`:Receivable Payment @@receivablePayment:Receivable Payment` + ' - ' + this.vm.item.header.number
          );
          this.rptName = 'Receivable';
        } else {
          this.vm.subLedger = SUBLEDGER_AP;
          this.vm.paymentTypeName = $localize`:Payable @@payable:Payable`;
          this.titleService.setTitle(
            $localize`:Payable Payment @@payablePayment:Payable Payment` + ' - ' + this.vm.item.header.number
          );
          this.rptName = 'Payable';
          // Derive payable type (AP vs Refund) from the loaded document so the radio reflects saved state
          this.derivePayableTypeFromLoadedPayment();
        }
        // Ensure arrays exist for templates even in edit
        if (!Array.isArray(this.vm.item.detail)) {
          this.vm.item.detail = [{id: 1, amount: ''}];
        }
        if (!Array.isArray(this.vm.item.applied)) {
          this.vm.item.applied = [];
        }
        this.spliceEntities();

        // this.vm.emailSend.ToEmail = this.FilterObject(this.vm.entity, {id: this.vm.item.header.entity_id}, true)[0].email;

        this.vm.item.header.header_date = this.dateFilter.GetDateFormat(this.vm.item.header.header_date);
        // tempDate.substring(5, 7) + '/' + tempDate.substring(8, 10) + '/' + tempDate.substring(0, 4);

        this.vm.clearedDate = '';
        for (const obj of this.vm.item.detail) {
          obj.amount = Number(obj.amount);
          if (obj.cleared_date) {
            this.vm.clearedDate = obj.cleared_date;
          }
        }
        for (let x = this.vm.item.detail.length - 1; x > -1; x--) {
          if (this.vm.item.detail[x].control_line === 1) {
            this.vm.item.detail.splice(x, 1);
          }
        }
        this.vm.applied = this.vm.item.applied;
        this.vm.invoices = [];
        this.vm.manualAmount = false;
        this.removeDuplicates();
        this.reverseHeaderAmount();
        this.calcTotals();
        resolve();
      }

      // set values passed to batch change modal
      if (this.vm.subLedger === SUBLEDGER_AP) {
        this.batchType = String(BATCH_TYPE_AP);
        this.vm.batchType = String(BATCH_TYPE_AP);
      } else {
        this.batchType = String(BATCH_TYPE_AR);
        this.vm.batchType = String(BATCH_TYPE_AR);
      }

      if (this.vm.bank.length === 1) {
        this.vm.item.header.bank_id = this.vm.bank[0].id;
      }

      if (this.vm.company.length === 1) {
        this.vm.item.header.company_id = this.vm.company[0].id;
      }

      if (this.vm.currency.length === 1) {
        this.vm.item.header.currency_id = this.vm.currency[0].id;
      }
      if (this.vm.paymentType.length === 1) {
        this.vm.item.header.payment_type_id = this.vm.paymentType[0].id;
      }

      if (this.action === 'email') {
        this.email();
        resolve();
      } else {
        this.changeDetect.detectChanges();
        this.vm.isLoaded = true;
        resolve();
      }

      // For existing AP Stripe Connect payments, fetch live isCancellable + status from the AP GET endpoint
      if (this.vm.subLedger === SUBLEDGER_AP) {
        void this.loadApStripeTransactionStatus();
      }
    });
  }

  /**
   * Handler for the Type Of Payable selector. Preselects AP; switching to Refund
   * enables refund mode (sets subledger to AR) using setRefundModeEnabled().
   */
  onPayableTypeChange(type: 'ap' | 'refund') {
    try {
      const isAP = Number(this.vm?.item?.batch?.type_id || this.vm?.item?.batchTypeId || 0) === BATCH_TYPE_AP;
      const prevType = this.vm.payableType as 'ap' | 'refund';
      // If AR or batch not yet known, retain previous lightweight behavior
      if (isAP) {
        this.vm.payableType = type;
        if (type === 'refund') {
          this.setRefundModeEnabled(true);
        } else {
          this.setRefundModeEnabled(false);
        }
        this.computePaymentMode();
        this.calcTotals();
        return;
      }

      // In AP context, switching the radio should clear entity selection and invoice lines.
      const hasEntity = !!this.vm?.item?.header?.entity_id;
      const hasRows = (Array.isArray(this.vm?.invoices) && this.vm.invoices.length > 0)
        || (Array.isArray(this.vm?.applied) && this.vm.applied.length > 0);
      const hasTotals = (Number(this.vm?.totalPaid || 0) !== 0) || (Number(this.vm?.totalOwing || 0) !== 0);

      const proceed = () => {
        // Apply selection and clear entity/invoices for AP only
        this.vm.payableType = type;
        this.clearEntityAndInvoices();
        if (type === 'refund') {
          this.setRefundModeEnabled(true);
        } else {
          this.setRefundModeEnabled(false);
        }
        this.computePaymentMode();
        this.calcTotals();
      };

      const cancel = () => {
        // Revert visual selection
        this.vm.payableType = prevType;
        this.changeDetect.detectChanges();
      };

      // Block if locked/posted
      if (this.isLocked() || this.isPrinted()) {
        cancel();
        return;
      }

      if (hasEntity || hasRows || hasTotals) {
        const messages: string[] = [
          $localize`:Switch type?@@switchTypeQuestion:Switch type?`,
          $localize`:Switching the payable type will clear the selected entity and invoice lines. Continue?@@switchTypeWillClear:Switching the payable type will clear the selected entity and invoice lines. Continue?`
        ];
        this.confirmDialogService.confirmThis(messages, proceed, cancel);
      } else {
        proceed();
      }
    } catch {
      // no-op
    }
  }

  /**
   * Clear selected entity and invoice table data when switching AP payable type.
   * Does not auto-fetch new invoices. Respects vm.manualAmount semantics for the Amount field.
   */
  private clearEntityAndInvoices(): void {
    try {
      // Clear entity selection and related UI fields
      if (this.vm?.item?.header) {
        this.vm.item.header.entity_id = '';
        this.vm.item.header.entityInput = '';
        this.vm.item.header.bank_id = '';
        this.vm.item.header.company_id = '';
        this.vm.item.header.currency_id = '';
        this.vm.item.header.payment_type_id = '';
        this.vm.totalOwing = 0;
        this.vm.totalPaid = 0;
        this.vm.totalBalance = 0;
        this.vm.item.header.detail_total = 0;
        this.vm.manualAmount = false;
      }
      this.vm.entityAddress = [];
      // Reset bank dropdown to full list when entity is cleared
      if (Array.isArray(this.vm?.allBanks)) {
        this.vm.bank = this.vm.allBanks;
      }

      // Clear invoice/applied lists
      this.vm.invoices = [];
      this.vm.applied = [];
      if (this.vm?.item) {
        this.vm.item.applied = [];
      }

      // Reset totals
      this.vm.totalOwing = 0;
      this.vm.totalPaid = 0;
      this.vm.totalBalance = 0;

      // Respect manualAmount behavior for Amount
      if (!this.vm.manualAmount) {
        // UI-driven mode: blank the Amount so user gets a fresh start
        if (this.vm?.item?.header) {
          this.vm.item.header.detail_total = '';
        }
      }

      // Reset helper flags
      this.vm.getInvoices = false;
      this.invoicesStillNotPaidFound = false;

      // Update toolbar buttons and refresh bindings
      try {
        this.updateHeaderButtonStates();
      } catch {
      }
      this.changeDetect.detectChanges();
    } catch {
      // keep UI resilient
    }
  }

  /**
   * Derive the payable type selection (AP vs Refund) from a loaded existing AP payment.
   * Does not change subledger; only sets vm.isRefund and vm.payableType so the radio reflects the saved doc.
   * Heuristics:
   *  - If detail[0].amount is negative => Refund
   *  - Else if vm.isRefund already truthy on load => Refund
   *  - Else => AP
   */
  private derivePayableTypeFromLoadedPayment(): void {
    try {
      const isAP = Number(this.vm?.item?.batch?.type_id || this.vm?.item?.batchTypeId || 0) === BATCH_TYPE_AP;
      if (!isAP) {
        this.computePaymentMode();
        return;
      }
      const amt0 = Number(this.vm?.item?.header?.detail_total ?? 0);
      // Check-print payments are never refunds even if stored as negative (AP sign convention)
      const isCheck = this.isPaymentTypeCheck();
      const loadedIsRefund = !isCheck && (!!this.vm?.isRefund || amt0 < 0);
      // Only set flags; do not flip subledger here. Fetching logic will temporarily switch when needed.
      this.vm.isRefund = loadedIsRefund;
      this.vm.payableType = loadedIsRefund ? 'refund' : 'ap';
      // Recompute mode now that isRefund and payableType are set
      this.computePaymentMode();
      // Recompute totals to update table headings/values based on refund mode
      this.calcTotals();
    } catch {
      // keep UI resilient
    }
  }

  async loadEntity() {
    // console.log('calling api');
    const res = await lastValueFrom(
      this.tableDataService.getApiListData('entity', '?state=active&pageNumber=0&pageSize=999999').pipe(take(1))
    );
    this.vm.entity = res.Data;
    // console.log('entity: ', this.vm.entity);
    this.buildEntityName();
    if (this.vm.entity.length > 0) {
      // console.log('setting');
      this.vm.entityIsLoaded = true;
    }
    // console.log('returning');
  }

  async loadLookups(): Promise<void> {
    // Prepare basic state
    if (this.paymentId === 'newAP') {
      this.vm.item = {batchTypeId: String(BATCH_TYPE_AP)};
    } else if (this.paymentId === 'newAR') {
      this.vm.item = {batchTypeId: String(BATCH_TYPE_AR)};
    }
    this.vm.buttonsDisabled = false;
    this.vm.subLedger = '';
    this.vm.alert = {message: []};
    this.vm.emailSend = {};
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences', ''));

    // Ensure entities are loaded first (many dependents need it)
    await this.loadEntity();

    // Build lookup observables
    const bank$ = this.tableDataService
      .getApiListData('bank', '?state=active&pageNumber=0&pageSize=999999')
      .pipe(take(1));
    const company$ = this.tableDataService
      .getApiListData('company', '?state=active&pageNumber=0&pageSize=999999')
      .pipe(take(1));
    const currency$ = this.tableDataService
      .getApiListData('currency', '?state=active&pageNumber=0&pageSize=999999')
      .pipe(take(1));
    const checkStock$ = this.tableDataService
      .getApiListData('check_stock', '?state=active&pageNumber=0&pageSize=999999')
      .pipe(take(1));
    const paymentType$ = this.tableDataService
      .getApiListData('payment_type', '?state=active&pageNumber=0&pageSize=999999')
      .pipe(take(1));
    const entityType$ = this.tableDataService
      .getApiListData('entity_type', '?state=active&pageNumber=0&pageSize=999999')
      .pipe(take(1));
    const terms$ = this.tableDataService
      .getApiListData('term/complete', '?state=active&pageNumber=0&pageSize=999999')
      .pipe(take(1));

    await lastValueFrom(
      forkJoin({
        bank: bank$,
        company: company$,
        currency: currency$,
        checkStock: checkStock$,
        paymentType: paymentType$,
        entityType: entityType$,
        terms: terms$
      })
        .pipe(
          tap((res: any) => {
            this.vm.allBanks = res.bank?.Data || [];
            this.vm.bank = this.vm.allBanks;
            this.isBankLoaded = true;

            this.vm.company = res.company?.Data || [];
            this.vm.companyIsLoaded = true;

            this.vm.currency = res.currency?.Data || [];
            this.vm.currencyIsLoaded = true;

            this.vm.checkStock = res.checkStock?.Data || [];

            this.vm.paymentType = res.paymentType?.Data || [];
            this.vm.paymentTypeIsLoaded = true;

            // Apply initial filtering based on current Stripe ACH verification status
            this.applyStripePaymentTypeFilterForCurrentEntity();

            this.vm.entity_type = res.entityType?.Data || [];

            this.vm.terms = res.terms?.Data || [];
          })
        )
    );

    // Initialize simple flags only; do NOT reset vm.item here
    this.vm.getInvoices = false;

    // If an entity is already selected, load Stripe setup so filtering is accurate
    this.loadStripeSetupForEntityIfStripeType();
  }

  getPaymentEditData() {
    this.tableDataService
      .getData('entry', this.paymentId)
      .pipe(
        take(1),
        tap((result: any) => {
          console.log('[PaymentForm][getPaymentEditData] raw API result:', result);
          this.vm.isRefund = false;
          this.vm.item = result;
          // Normalize all display amounts via single normalization layer (Phase 2)
          this.normalizePaymentOnLoad();

          this.printed = this.isPrinted();
          this.locked = this.isLocked();
          this.vm.buttonsDisabled = result.locked;
          this.filterEntity();
        }),
        switchMap(() => {
          const entId = this.vm?.item?.header?.entity_id;
          if (entId) {
            const paramStr = this.buildAddressesQueryParams(entId);
            return this.tableDataService.getData('entity_address/addresses', '?' + paramStr).pipe(
              take(1),
              tap((res: any) => {
                this.vm.entityAddress = res.Data;
                this.vm.buttonsDisabled = res.locked;
              })
            );
          }
          return of(null);
        }),
        finalize(() => {
          this.init().then(() => {
            this.populateHeaderDefaultsForExisting();
            this.captureOriginalSnapshot();
            // Recompute payment mode after init() has set vm.payableType and vm.isRefund
            this.computePaymentMode();
            this.vm.isLoaded = true;
            this.submitted = true;
            // After existing payment is initialized, fetch Stripe setup if type is Stripe
            this.loadStripeSetupForEntityIfStripeType();
          });
        })
      )
      .subscribe({
        error: (error: any) => {
          console.error('Error getting payment edit data:', error);
          this.notification.showErrorToast('Error loading payment data');
        }
      });
  }

  private captureOriginalSnapshot(sourceItem?: any): void {
    this.originalDocument = this.buildSnapshot(sourceItem);
  }

  private populateHeaderDefaultsForExisting(): void {
    try {
      const pid = String(this.paymentId || '').toLowerCase();
      if (pid === 'newap' || pid === 'newar' || this.paymentId === 'newAP' || this.paymentId === 'newAR') {
        return;
      }
      const header = this.vm?.item?.header;
      if (!header) {
        return;
      }
      const entityMatch = (this.vm?.entity || []).find((e: any) => e && e.id === header.entity_id);
      if (entityMatch) {
        this.applyEntityDefaults(entityMatch);
      }
      if (!header.bank_id && Array.isArray(this.vm?.bank) && this.vm.bank.length === 1) {
        header.bank_id = this.vm.bank[0]?.id;
      }
      if (!header.company_id && Array.isArray(this.vm?.company) && this.vm.company.length === 1) {
        header.company_id = this.vm.company[0]?.id;
      }
      if (!header.currency_id && Array.isArray(this.vm?.currency) && this.vm.currency.length === 1) {
        header.currency_id = this.vm.currency[0]?.id;
      }
      if (!header.payment_type_id && Array.isArray(this.vm?.paymentType) && this.vm.paymentType.length === 1) {
        header.payment_type_id = this.vm.paymentType[0]?.id;
      }
    } catch {
      // ignore
    }
  }

  filterEntity() {
    if (this.vm.item.header.entity_id) {
      const entityCheck = this.vm.entity.find((x) => x.id === this.vm.item.header.entity_id);
      if (entityCheck) {
        this.vm.item.header.entityInput = entityCheck.name;

        // Apply default header values from the selected entity, without overwriting user input
        this.applyEntityDefaults(entityCheck);

        let paramStr = '';
        paramStr += 'billing_address=1';
        paramStr += '&entity_id=' + (this.vm.item.header.entity_id ? this.vm.item.header.entity_id : '');
        this.tableDataService.getData('entity_address/addresses', '?' + paramStr).subscribe((result: any) => {
          this.vm.entityAddress = result.Data;
          this.vm.buttonsDisabled = result.locked;
        });
      } else {
        this.vm.buttonsDisabled = false;
        // this.vm.item.header.entityInput = $localize`:Entity Not found @@entityNotfound:Entity Not found`;
        this.notification.showWarningToast(
          $localize`:The existing entity is no longer valid, please select another entity. @@theexistingentityisnolongervalidpleaseselectanotherentity:The existing entity is no longer valid, please select another entity.` +
            '  '
        );
        this.vm.entityError = true;
        this.vm.item.header.entity_id = '';
      }
    }
  }

  navigateTo(id, print = false) {
    this.tableDataService.getData('entry/' + id).subscribe((result: any[]) => {
      // this.localStorage.StorageSet('paymentItem', JSON.stringify(result));
      this.router.navigateByUrl('/transactions/payment/form?paymentId=' + id + '&batchId=').then();
      if (print) {
        this.router
          .navigate(['/transactions/payment/form'], { queryParams: { paymentId: id, action: 'print' } })
          .then();
      } else {
        this.router.navigate(['/transactions/payment/form'], { queryParams: { paymentId: id } }).then();
      }
    });
  }

  // Thin wrapper — delegates to the consolidated loader.
  // Called from the "Get Invoices" button (new payments, user-triggered refresh).
  getInvoicesEntity(
    restoreStateAfterFetch?: { subLedger: string; isRefund: boolean; appliedOnly?: boolean },
    appliedOnly?: boolean
  ) {
    if (!this.vm.item.header.entity_id || !this.vm.item.header.company_id || !this.vm.item.header.header_date) {
      this.notification.showWarningToast(
        $localize`:Entity, date, and company are required @@entitydateandcompanyarerequired:Entity, date, and company are required`
      );
      return;
    }
    const appOnly = typeof appliedOnly !== 'undefined' ? !!appliedOnly : !!restoreStateAfterFetch?.appliedOnly;
    void this.loadInvoicesForPayment({appliedOnly: appOnly, userTriggered: true});
  }

  // ── PHASE 7 — CONSOLIDATED INVOICE FETCH ─────────────────────────────────
  // Single method for all invoice loading — called from init() and getInvoicesEntity().
  // For existing payments passes payment_id so already-applied invoices are included.
  // For new payments fetches open invoices only.
  // ─────────────────────────────────────────────────────────────────────────
  async loadInvoicesForPayment(options: { appliedOnly?: boolean; userTriggered?: boolean } = {}): Promise<void> {
    const {appliedOnly = false, userTriggered = false} = options;
    const header = this.vm?.item?.header;
    const isExisting = this.isExistingPayment();

    // Determine effective subledger — fallback to batch.type_id when vm.subLedger not yet set
    const batchTypeId = String(this.vm?.item?.batch?.type_id || '').trim();
    const fetchSubLedger = this.vm.subLedger === SUBLEDGER_AR || batchTypeId === '3' ? SUBLEDGER_AR : SUBLEDGER_AP;

    // credit_memos_only: always false — credit memos are regular invoices with negative amounts
    // and must not be excluded from the invoice fetch in AR mode
    const creditMemosOnly = false;

    const date = this.dateFilter.GetDateFormat(header?.header_date);

    // Build query — on auto-load for existing payments, pass payment_id so already-applied invoices
    // are included. When user explicitly clicks Get Invoices, fetch all open invoices without
    // payment_id so the full open invoice list is returned.
    const useExistingPath = isExisting && !userTriggered;
    const paramString = useExistingPath
      ? this.buildEntryInvoicesCheckParams(
        header.entity_id, header.company_id, fetchSubLedger,
        header.id, date, creditMemosOnly as any, appliedOnly as any
      )
      : this.buildEntryQueryParams(
        header.entity_id, header.company_id, date,
        fetchSubLedger, String(creditMemosOnly), appliedOnly
      );

    // Preserve any applied_amount values the user has already entered
    const existingApplied = new Map<string, number>();
    (this.vm.invoices || []).forEach((inv: any) => {
      if (inv?.id != null && inv.applied_amount != null && Number(inv.applied_amount) !== 0) {
        existingApplied.set(String(inv.id), Number(inv.applied_amount));
      }
    });

    const result: any = await lastValueFrom(
      this.tableDataService.getData('entry/invoices', '?' + paramString).pipe(take(1))
    );
    this.vm.invoices = result;

    // Re-apply any amounts the user had already entered before this fetch
    if (existingApplied.size > 0) {
      (this.vm.invoices || []).forEach((inv: any) => {
        const prev = existingApplied.get(String(inv?.id));
        if (prev !== undefined) {
          inv.applied_amount = prev;
        }
      });
      // Keep pre-applied invoices at the top
      this.vm.invoices = [
        ...(this.vm.invoices || []).filter((inv: any) => existingApplied.has(String(inv?.id))),
        ...(this.vm.invoices || []).filter((inv: any) => !existingApplied.has(String(inv?.id))),
      ];
    }

    // Warn when user explicitly clicked Get Invoices and nothing came back.
    // Suppress on auto-load for existing payments (applied rows are in vm.applied, not vm.invoices).
    if (userTriggered && !this.vm.invoices?.length) {
      this.notification.showWarningToast('No open invoices found.', 'Warning');
    }

    // Auto-apply a preset invoice if one was passed via query param
    if (this.presetInvoiceId) {
      const match = (this.vm.invoices || []).find((inv: any) => String(inv.id) === String(this.presetInvoiceId));
      if (match) {
        const owing = Math.max(0, Number(match.detail_total || 0) - Number(match.payment_applied_total || 0));
        match.applied_amount = Math.round(owing * 100) / 100;
      }
      this.presetInvoiceId = null;
    }

    this.vm.manualAmount = false;
    this.removeDuplicates();
    this.reverseHeaderAmount();
    this.calcTotals();
  }

  // Returns true when the currently-selected entity is marked receivable
  isSelectedEntityReceivable(): boolean {
    try {
      const entId = this.vm?.item?.header?.entity_id;
      if (!entId) {
        return false;
      }
      const ent = (this.vm?.entity || []).find((e: any) => e && e.id === entId);
      return !!ent?.receivable;
    } catch {
      return false;
    }
  }

  // Toggle settings used by checkForRefund() without relying on amount sign
  private setRefundModeEnabled(enable: boolean): void {
    if (enable) {
      this.vm.isRefund = true;
      this.vm.subLedger = SUBLEDGER_AP; // refund pulls AR credits
    } else {
      this.vm.isRefund = false;
      this.vm.subLedger = SUBLEDGER_AP; // default back to AP context
    }
  }

  // UI handler for the "Get Credit Memos" button
  onGetCreditMemosClick(): void {
    // Must be AR and selected entity must be receivable (eligible for credits)
    if (this.vm?.subLedger !== SUBLEDGER_AR || !this.isSelectedEntityReceivable()) {
      return;
    }

    const prev = {subLedger: this.vm.subLedger, isRefund: !!this.vm.isRefund};

    // First try the existing logic (may depend on entered amount)
    const wasDetected = this.checkForRefund();

    // If not detected (e.g., no negative amount entered), force refund mode for fetching credit memos
    if (!wasDetected) {
      this.setRefundModeEnabled(true);
    }

    // Fetch using current (possibly forced) refund settings, then restore state so normal AP operations continue
    this.getInvoicesEntity(prev);
  }

  deleteInvoiceRow(rowIndex) {
    this.vm.invoices.splice(rowIndex, 1);
    this.calcTotals();
  }

  deleteAppliedRow(rowIndex) {
    this.vm.applied.splice(rowIndex, 1);
    this.calcTotals();
  }

  clearPriorSelections() {
    this.vm.item.header.company_id = '';
    this.vm.applied = [];
    this.vm.invoices = [];
  }

  async getInvoicesStillNotPaid(): Promise<any> {
    this.vm.datetemp = this.dateFilter.GetDateFormat(this.vm.item.header.header_date);
    const paramString = this.buildEntryInvoicesCheckParams(
      this.vm.item.header.entity_id,
      this.vm.item.header.company_id,
      this.vm.subLedger,
      this.vm.item.header.id,
      this.vm.datetemp,
      false,
      false,
    );

    // console.log('fetch invoices still not paid to test against previously paid params', paramString);
    const res = await lastValueFrom(
        this.tableDataService.getData('entry/invoices', '?' + paramString).pipe(take(1))
    );
    this.testInvoices = res;
    //console.log('invoices to test against previously paid params 972: ', paramString);
    // console.log('invoices ok to pay at fetch return line 973:', this.testInvoices);

    const testTF = await this.checkForSelectedInvoices();

    return this.invoicesStillNotPaidFound;
  }

  async checkForSelectedInvoices() {
    // Only enforce this for AR
    if (String(this.vm?.subLedger).toLowerCase() !== String(SUBLEDGER_AR)) {
      this.invoicesStillNotPaidFound = true;
      return true;
    }

    // If we didn’t receive an unpaid list, assume OK
    const gotUnpaidList = Array.isArray(this.testInvoices) && this.testInvoices.length >= 0;
    if (!gotUnpaidList) {
      this.invoicesStillNotPaidFound = true;
      return true;
    }
    // console.log('invoices still not paid found: ', this.testInvoices);
    // Build a fast lookup of currently unpaid invoice ids from the API
    const unpaidIds = new Set((this.testInvoices || []).map((t: any) => t.id));

    // Collect only the lines the user has actually selected (applied_amount truthy)
    const selectedNow: Array<{ id: any; number?: string }> = [];

    // 1) Lines already on the payment (applied grid)
    // for (const a of this.vm?.applied || []) {
    //   if (a?.applied_amount) {
    //     selectedNow.push({ id: a.applied_header_id, number: a.number });
    //   }
    // }

    // 2) Newly fetched invoices not yet persisted on the payment
    for (const inv of this.vm?.invoices || []) {
      if (inv?.applied_amount > 0) {
        selectedNow.push({id: inv.id, number: inv.number});
      }
    }
    // console.log('fetched invoices to pay: ', this.testInvoices);
    // console.log('invoices to SELECTED pay: ', selectedNow);
    // console.log('unpaid invoices array: ', unpaidIds);

    this.previousPaidInvoices = [];
    this.invoicesStillNotPaidFound = true; // assume OK

    // Any selected id not present in unpaid list has been paid since selection
    for (const s of selectedNow) {
      if (!unpaidIds.has(s.id)) {
        this.invoicesStillNotPaidFound = false;
        if (s?.number) {
          this.previousPaidInvoices.push(s.number);
        }
      }
    }

    if (!this.invoicesStillNotPaidFound && this.previousPaidInvoices.length) {
      this.notification.showWarningToast(
        $localize`:Some invoices have been paid since selection - reselect @@someinvoiceshavebeenpaid:Some invoices have been paid since selection: ` +
        this.previousPaidInvoices.join(', ')
      );
    }

    return this.invoicesStillNotPaidFound;
  }

  //
  reverseHeaderAmount() {
    for (const obj of this.vm.applied) {
      if (obj.account_id?.toLowerCase() === SUBLEDGER_AP) {
        if (this.vm.subLedger === SUBLEDGER_AP) {
          obj.payment_applied_total = Number(obj.payment_applied_total);
          obj.detail_total = Number(obj.detail_total);
        }
        if (this.vm.subLedger === SUBLEDGER_AR) {
          obj.payment_applied_total = 0 - Number(obj.payment_applied_total);
          obj.detail_total = 0 - Number(obj.detail_total);
        }
      }
      if (obj.account_id?.toLowerCase() === SUBLEDGER_AR) {
        if (this.vm.subLedger === SUBLEDGER_AP) {
          obj.payment_applied_total = 0 - Number(obj.payment_applied_total);
          obj.detail_total = 0 - Number(obj.detail_total);
        }
        if (this.vm.subLedger === SUBLEDGER_AR) {
          obj.payment_applied_total = Number(obj.payment_applied_total);
          obj.detail_total = Number(obj.detail_total);
        }
      }
    }
    for (const obj of this.vm.invoices) {
      if (obj.account_id?.toLowerCase() === SUBLEDGER_AP) {
        if (this.vm.subLedger === SUBLEDGER_AP) {
          obj.payment_applied_total = 0 - Number(obj.payment_applied_total);
          obj.detail_total = Number(obj.detail_total);
        } else if (this.vm.subLedger === SUBLEDGER_AR) {
          obj.payment_applied_total = Number(obj.payment_applied_total);
          obj.detail_total = 0 - Number(obj.detail_total);
        }
      }
      if (obj.account_id?.toLowerCase() === SUBLEDGER_AR) {
        if (this.vm.subLedger === SUBLEDGER_AP) {
          obj.payment_applied_total = Number(obj.payment_applied_total);
          obj.detail_total = Number(obj.detail_total);
        } else if (this.vm.subLedger === SUBLEDGER_AR) {
          obj.payment_applied_total = Number(obj.payment_applied_total);
          obj.detail_total = Number(obj.detail_total);
        }
      }
    }
  }

  // ENTITIES

  spliceEntities() {
    for (let y = this.vm.entity.length - 1; y > -1; y--) {
      if (
        this.vm.subLedger === SUBLEDGER_AR &&
        this.vm.entity[y].receivable === 0 &&
        (this.vm.entity[y].id !== this.vm.item.header.entity_id || !this.vm.item.header.entity_id)
      ) {
        this.vm.entity.splice(y, 1);
      } else if (
        this.vm.subLedger === SUBLEDGER_AP &&
        this.vm.entity[y].payable === 0 &&
        (this.vm.entity[y].id !== this.vm.item.header.entity_id || !this.vm.item.header.entity_id)
      ) {
        this.vm.entity.splice(y, 1);
      }
    }
    this.buildEntityName();
  }

  updateEntity() {
    this.vm.startEntityName = 0;

    this.tableDataService
      .getApiListData('entity', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        // const data: any = result.Data;
        this.vm.entity = result.Data;
        this.spliceEntities();
      });
  }

  private buildEntityName(): void {
    this.vm.entityName = [];
    const list: any[] = Array.isArray(this.vm?.entity) ? this.vm.entity : [];
    for (const entity of list) {
      const name = entity?.name ?? '';
      if (name) {
        this.vm.entityName.push({name});
      }
    }
  }

  async selectEntityModal(entityName) {
    this.clearPriorSelections();
    this.vm.item.header.entity_id = '';
    for (const obj of this.vm.entity) {
      if (obj.name === entityName) {
        this.vm.item.header.entityInput = entityName;
        this.vm.item.header.entity_id = obj.id;

        // Apply default header values from the entity and force-update dependent fields
        // so Company, Bank, Payment Type, and Currency change immediately on selection.
        this.applyEntityDefaults(obj, {force: true});

        // Ensure any listeners and dependent logic tied to the entity input change are triggered
        // The modal selection sets the field programmatically, so fire the same handler used by typing.
        this.onEntityInputChange(entityName);

        // Re-fetch Stripe profile for the newly selected entity and re-filter payment types
        await this.loadStripeSetupForEntityIfStripeType();

        let paramString = '';
        paramString += 'billing_address=1';
        paramString += '&entity_id=' + (this.vm.item.header.entity_id ? this.vm.item.header.entity_id : '');

        this.tableDataService.getData('entity_address/addresses', '?' + paramString).subscribe((result: any) => {
          this.vm.entityAddress = result.Data;
          // console.log(result);
          if (!this.vm.entityAddress.length) {
            this.notification.showWarningToast(
              'No Billing Address. Select an address as Billing Address before continuing'
            );
            this.vm.noBillToError = true;
            return;
          } else {
            this.vm.noBillToError = false;
            const entityID = this.FilterObject(this.vm.entity, { name: this.vm.item.header.entityInput }, true)[0].id;
            // const entityName = this.FilterObject(this.vm.entity, { name: this.vm.item.header.entityInput }, true)[0].name;
            this.vm.emailSend.ToEmail = this.FilterObject(this.vm.entity, { id: entityID }, true)[0].email;
          }
        });

        this.vm.emailSend.ToEmail = this.FilterObject(this.vm.entity, { id: obj.id }, true)[0].email;
        break;
      }
    }
  }

  /**
   * Populate payment header defaults (company, bank, payment type, currency) from the selected entity.
   * Does not overwrite fields already chosen by the user. Uses common fallback property names.
   */
  private applyEntityDefaults(entity: any, options?: { force?: boolean }): void {
    try {
      if (!entity) {
        return;
      }

      const header = this.vm?.item?.header || (this.vm.item.header = {
        stripe_customer_id: null,
        stripe_payment_method_id: null,
        stripe_payment_intent_id: null,
        stripe_transaction_id: null,
        stripe_status: null,
        stripe_last_status_utc: null
      });
      const force = !!options?.force;

      const setField = (key: string, value: any) => {
        if (value === undefined || value === null || value === '') {
          return;
        }
        if (force) {
          header[key] = value;
        } else if (!header[key]) {
          header[key] = value;
        }
      };

      // Company
      const entityCompanyId = entity.company_id || entity.default_company_id || entity.co_id;
      setField('company_id', entityCompanyId);

      // Bank — filter dropdown to only the entity's bank
      const entityBankId = entity.bank_id || entity.default_bank_id;
      setField('bank_id', entityBankId);
      // Always filter the bank dropdown regardless of whether bank_id was already set
      if (entityBankId && Array.isArray(this.vm?.allBanks)) {
        const entityBank = this.vm.allBanks.filter((b: any) => b.id === entityBankId);
        this.vm.bank = entityBank.length > 0 ? entityBank : this.vm.allBanks;
      } else if (!entityBankId && Array.isArray(this.vm?.allBanks)) {
        this.vm.bank = this.vm.allBanks;
      }

      // Payment Type
      const entityPaymentTypeId = entity.payment_type_id || entity.default_payment_type_id;
      setField('payment_type_id', entityPaymentTypeId);

      // Currency
      const entityCurrencyId = entity.currency_id || entity.default_currency_id;
      setField('currency_id', entityCurrencyId);
    } catch {
      // ignore — do not block UI if defaults cannot be applied
    }
  }

  /**
   * When the Entity input text changes, attempt to resolve the entity record by name
   * and populate dependent header fields (company, bank, payment type, currency)
   * using applyEntityDefaults(). Does not overwrite user-entered values.
   */
  async onEntityInputChange(value: string): Promise<void> {
    // console.log('on change fired', value);
    try {
      const name = (value || '').toString().trim();
      // if (!name) {
      //   // Clearing the input should also clear the selected entity id
      //   if (this.vm?.item?.header) {
      //     this.vm.item.header.entity_id = '';
      //   }
      //   return;
      // }

      // Find entity by exact name match first
      const list: any[] = Array.isArray(this.vm?.entity) ? this.vm.entity : [];
      const exact = list.find((e: any) => e && e.name && e.name.toString().trim() === name);
      const match = exact || list.find((e: any) => e && e.name && e.name.toString().toLowerCase() === name.toLowerCase());
      if (match) {
        this.vm.item.header.entity_id = match.id;
        // Apply defaults without overwriting existing header selections
        // Force update on explicit user change so the dependent fields update immediately
        this.applyEntityDefaults(match, {force: true});
        // Re-fetch Stripe profile for the new entity and re-filter payment types
        await this.loadStripeSetupForEntityIfStripeType();
      }
    } catch {
      // no-op; keep UX resilient
    }
  }

  // PHASE 2 — NORMALIZATION LAYER
  // Single entry point for normalizing a loaded payment item for display.
  // All Math.abs sign-handling on load should live here — not scattered through getPaymentEditData,
  // derivePayableTypeFromLoadedPayment, calcTotals, etc.
  private normalizePaymentOnLoad(): void {
    try {
      const header = this.vm?.item?.header;
      if (!header) {
        return;
      }
      // header.detail_total must NOT be overwritten on load — it is the authoritative payment amount
      // stored by the API and must be sent back unchanged on PATCH.
      // payment_applied_total is used for display only (see template); it must never replace detail_total.
      // Normalize detail_total to positive magnitude for display only.
      header.detail_total = Math.abs(Number(header.detail_total || 0));
      // detail[0].amount is the display magnitude of the cash line
      this.syncDetailAmountsFromHeader();
      // applied_amount rows are always positive for display
      // payment_applied_total is normalized to positive here so downstream calcs need no Math.abs
      if (Array.isArray(this.vm?.item?.applied)) {
        for (const row of this.vm.item.applied) {
          if (row && row.applied_amount != null) {
            row.applied_amount = Math.abs(Number(row.applied_amount || 0));
          }
          if (row && row.payment_applied_total != null) {
            row.payment_applied_total = Math.abs(Number(row.payment_applied_total || 0));
          }
        }
      }
      // Normalize header.payment_applied_total to positive for display
      if (header.payment_applied_total != null) {
        header.payment_applied_total = Math.abs(Number(header.payment_applied_total || 0));
      }
      // Ensure paymentMode reflects the loaded payment type before template renders
      this.computePaymentMode();
    } catch {
      // keep UI resilient
    }
  }

  // Single entry point for preparing a payment item for save.
  // API now owns all sign logic — Angular always sends positive amounts.
  private preparePaymentForSave(): void {
    try {
      const hdrAmt = Math.abs(Number(this.vm?.item?.header?.detail_total || 0));
      this.vm.item.header.detail_total = hdrAmt;

      if (!Array.isArray(this.vm.item.detail) || this.vm.item.detail.length === 0) {
        this.vm.item.detail = [{id: 1, amount: hdrAmt, debit_credit: hdrAmt, quantity: 1} as any];
      } else {
        for (const d of this.vm.item.detail) {
          if (d) {
            (d as any).amount = hdrAmt;
            (d as any).debit_credit = hdrAmt;
            (d as any).quantity = 1;
          }
        }
      }
    } catch {
      // keep UI resilient
    }
  }

  // UTILITIES
  // Keep payment detail amounts populated with positive quantities derived from header.detail_total
  // This is required for new documents (AR and AP) so detail rows are not left blank.
  private syncDetailAmountsFromHeader(): void {
    try {
      const headerAmt = Math.abs(Number(this.vm?.item?.header?.detail_total || 0));
      if (!this.vm?.item) {
        return;
      }
      if (!Array.isArray(this.vm.item.detail) || this.vm.item.detail.length === 0) {
        this.vm.item.detail = [{id: 1, amount: headerAmt, quantity: 1} as any];
        return;
      }
      // For payments, detail typically has a single bank/cash line; ensure amount is positive quantity
      for (const d of this.vm.item.detail) {
        if (d) {
          d.amount = headerAmt;
          (d as any).quantity = 1;
        }
      }
    } catch {
      // no-op; resilience
    }
  }

  // FINAL ENFORCEMENT BEFORE SAVE: amount must equal abs(debit_credit) and quantity must be 1
  private syncDetailAmountsFromDebitCredit(): void {
    try {
      if (!this.vm?.item || !Array.isArray(this.vm.item.detail)) {
        return;
      }
      for (const d of this.vm.item.detail) {
        if (!d) {
          continue;
        }
        const dc = Number((d as any).debit_credit || 0);
        (d as any).amount = Math.abs(dc);
        (d as any).quantity = 1;
      }
    } catch {
      // keep UX resilient
    }
  }

  removeDuplicates() {
    for (const obj of this.vm.applied) {
      const appliedId = String(obj.applied_header_id ?? '');
      for (let y = this.vm.invoices.length - 1; y > -1; y--) {
        if (String(this.vm.invoices[y].id ?? '') === appliedId) {
          this.vm.invoices.splice(y, 1);
        }
      }
    }
  }

  calcTotals() {
    this.vm.totalOwing = this.vm.totalPaid = this.vm.totalBalance = 0;
    // totalPaid is the sum of per-row applied_amounts only (do not include header amount here)
    for (const obj of this.vm.applied) {
      // Normalize applied_amount first
      if (obj.applied_amount) {
        if (!Number(obj.applied_amount) && obj.applied_amount !== '-') {
          obj.applied_amount = '';
        } else if (obj.applied_amount !== '-') {
          obj.applied_amount = Math.round(Number(obj.applied_amount) * 100) / 100;
          // Credit invoices (negative detail_total) reduce the payment amount; debits increase it
          const isCredit = Number(obj.detail_total || 0) < 0;
          this.vm.totalPaid += isCredit ? -Math.abs(Number(obj.applied_amount)) : Number(obj.applied_amount);
        }
      }
      // Credit rows reduce net owing; debit rows increase it
      const isCredit1 = Number(obj.detail_total || 0) < 0;
      this.vm.totalOwing += isCredit1 ? -this.getRowOwing(obj) : this.getRowOwing(obj);
    }
    for (const obj of this.vm.invoices) {
      const isCredit2 = Number(obj.detail_total || 0) < 0;
      this.vm.totalOwing += isCredit2 ? -this.getRowOwing(obj) : this.getRowOwing(obj);
      if (obj.applied_amount) {
        if (!Number(obj.applied_amount) && obj.applied_amount !== '-') {
          obj.applied_amount = '';
        } else if (obj.applied_amount !== '-') {
          obj.applied_amount = Math.round(Number(obj.applied_amount) * 100) / 100;
          // Credit invoices (negative detail_total) reduce the payment amount; debits increase it
          const isCredit = Number(obj.detail_total || 0) < 0;
          this.vm.totalPaid += isCredit ? -Math.abs(Number(obj.applied_amount)) : Number(obj.applied_amount);
        }
      }
    }
    this.vm.totalOwing = Math.round(this.vm.totalOwing * 100) / 100;
    this.vm.totalPaid = Math.round(this.vm.totalPaid * 100) / 100;
    // totalBalance = gross owing minus all applied payments.
    this.vm.totalBalance = this.vm.totalOwing - this.vm.totalPaid;
    this.vm.totalBalance = Math.round(this.vm.totalBalance * 100) / 100;
    // AP mode: always keep header amount in sync with total paid (sum of applied_amounts).
    // AR mode: header amount is entered by user and must never be overwritten by calcTotals.
    if (this.isApMode()) {
      this.setHeaderAmountFromTotals();
    }
    // this.vm.isLoaded = true;
    // Recompute toolbar button enabled/disabled states when totals change
    try {
      this.updateHeaderButtonStates();
    } catch {
    }
  }

  // Compute the Unapplied/Over Applied amount for header vs allocations, using abs(header) when refund
  getUnappliedAmount(): number {
    try {
      const headerVal = Number(this.vm?.item?.header?.detail_total || 0);
      const paid = Math.abs(Number(this.vm?.totalPaid || 0));
      const headerForMath = this.vm?.isRefund ? Math.abs(headerVal) : headerVal;
      const diff = Math.round((headerForMath - paid) * 100) / 100;
      return diff;
    } catch {
      return 0;
    }
  }

  /**
   * Checks if the current payment is an existing payment based on the paymentId.
   * A payment is considered existing if the paymentId is neither 'newAP' nor 'newAR'.
   *
   * @return {boolean} Returns true if the payment is existing, otherwise false.
   */
  isExistingPayment(): boolean {
    return this.paymentId !== 'newAP' && this.paymentId !== 'newAR';
  }

  getRowOwing(row: any): number {
    // Display column: always show gross invoice amount (absolute value — credits are negative stored).
    return Math.abs(Number(row?.detail_total || 0));
  }

  getRowBalance(row: any): number {
    // Remaining balance after all applied payments.
    // payment_applied_total and applied_amount are normalized to positive on load.
    // Credit invoices have negative detail_total — use absolute value for detailTotal.
    const detailTotal = Math.abs(Number(row?.detail_total || 0));
    const pat = Number(row?.payment_applied_total || 0);  // already positive after normalizePaymentOnLoad
    const applied = Number(row?.applied_amount || 0);     // already positive after normalizePaymentOnLoad
    const raw = pat > 0 ? detailTotal - pat : detailTotal - applied;
    return Math.round(raw * 100) / 100;
  }

  isRowOverApplied(row: any): boolean {
    const balance = this.getRowBalance(row);
    // Over-applied only when balance goes negative (paid more than owed).
    return balance < 0;
  }

  // Set header Amount from current totals with correct sign for mode (Refund negative, otherwise positive)
  private setHeaderAmountFromTotals(): void {
    try {
      const total = Math.abs(Number(this.vm?.totalPaid || 0));
      let effective = total;
      const isAR = String(this.vm?.item?.batch?.type_id) === String(BATCH_TYPE_AR);
      if (isAR) {
        effective = Math.abs(effective);
      } else {
        effective = this.vm?.isRefund ? -Math.abs(effective) : Math.abs(effective);
      }
      this.vm.item.header.detail_total = effective;
      // keep detail amounts populated with positive quantity
      this.syncDetailAmountsFromHeader();
      this.updateHeaderButtonStates();
    } catch {
      // no-op
    }
  }

  // Handle clicking Pay on a specific row: set row to full owing, then update totals and header amount sign-aware
  onPayRow(row: any): void {
    try {
      const isAR = String(this.vm?.item?.batch?.type_id) === String(BATCH_TYPE_AR);
      // Compute owing: use abs(payment_applied_total) since AP stores it as negative
      const owingStandard = Math.round((Math.abs(Number(row?.detail_total || 0)) - Math.abs(Number(row?.payment_applied_total || 0))) * 100) / 100;
      let owing = Math.max(0, owingStandard);
      if (this.vm?.isRefund) {
        const creditAvail = Math.max(0, Number(row?.payment_applied_total || 0));
        if (owing <= 0 && creditAvail > 0) {
          owing = creditAvail;
        }
      }
      if (isAR) {
        // AR: cap applied_amount to remaining unapplied (header amount minus already applied on OTHER rows)
        const headerAmt = Math.abs(Number(this.vm?.item?.header?.detail_total || 0));
        // Sum applied_amounts on all OTHER rows (not this row) to get already-committed amount
        const otherPaid = [...this.vm.applied, ...this.vm.invoices]
          .filter(r => r !== row)
          .reduce((sum, r) => sum + Math.abs(Number(r?.applied_amount || 0)), 0);
        const available = Math.max(0, Math.round((headerAmt - otherPaid) * 100) / 100);
        owing = Math.min(owing, available);
      }
      row.applied_amount = owing;
      this.calcTotals();
      // AR: header amount is fixed by user — never overwrite it from totals
      if (!isAR && !this.vm?.manualAmount) {
        this.setHeaderAmountFromTotals();
      }
    } catch {
      // resilient
    }
  }

  // Distribute a provided amount across rows without changing header.detail_total.
  // Used by Pay All when vm.manualAmount is true.
  private applyDistribute(amount: number) {
    // Standard allocation without changing the header amount
    let remaining = Math.round(Number(amount || 0) * 100) / 100;
    for (const invoice of this.vm.invoices) {
      invoice.applied_amount = '';
    }
    for (const obj of this.vm.applied) {
      const owing = Math.round((Math.abs(Number(obj.detail_total || 0)) - Math.abs(Number(obj.payment_applied_total || 0))) * 100) / 100;
      if (remaining > 0) {
        const take = Math.min(remaining, Math.max(0, owing));
        if (take > 0) {
          obj.applied_amount = take;
          remaining = Math.round((remaining - take) * 100) / 100;
        }
      }
      if (remaining <= 0) {
        break;
      }
    }
    if (remaining > 0) {
      for (const obj of this.vm.invoices) {
        const owing = Math.round((Math.abs(Number(obj.detail_total || 0)) - Math.abs(Number(obj.payment_applied_total || 0))) * 100) / 100;
        if (remaining > 0) {
          const take = Math.min(remaining, Math.max(0, owing));
          if (take > 0) {
            obj.applied_amount = take;
            remaining = Math.round((remaining - take) * 100) / 100;
          }
        }
        if (remaining <= 0) {
          break;
        }
      }
    }
    this.calcTotals();
  }

  // Handle Pay All button respecting vm.manualAmount
  onPayAll() {
    const isAR = String(this.vm?.item?.batch?.type_id) === String(BATCH_TYPE_AR);
    if (isAR) {
      // AR: header amount is fixed by user — distribute up to that amount across invoices
      this.apply();
      return;
    }
    // AP mode below
    // Use totalOwing as the target amount to allocate
    const target = Math.abs(Number(this.vm.totalOwing || 0));
    if (this.vm?.manualAmount) {
      // User has entered an Amount: do not change header, only affect allocations
      this.applyDistribute(target);
      return;
    }
    // User has not entered Amount: set header according to mode then apply()
    let effective = this.vm?.isRefund ? -Math.abs(target) : Math.abs(target);
    this.vm.item.header.detail_total = effective;
    // keep detail amounts populated with positive quantity
    this.syncDetailAmountsFromHeader();
    // Apply will overwrite per-row applied_amounts based on header.detail_total
    this.apply();
  }

  // Returns true if any applied_amount exists on any row (applied or invoices)
  hasAnyApplied(): boolean {
    try {
      // Fast path: rely on totals
      if (Math.abs(Number(this.vm?.totalPaid || 0)) > 0) {
        return true;
      }
      // Fallback: scan rows in case totals are stale
      const lists = [this.vm?.applied || [], this.vm?.invoices || []];
      for (const list of lists) {
        for (const row of list) {
          const amt = Number((row?.applied_amount || '').toString().split(',').join(''));
          if (isFinite(amt) && Math.abs(amt) > 0) {
            return true;
          }
        }
      }
      return false;
    } catch {
      return false;
    }
  }

  // Clear all per-row applied amounts without changing the header Amount
  onClearAll(): void {
    try {
      if (Array.isArray(this.vm?.invoices)) {
        for (const inv of this.vm.invoices) {
          if (inv) {
            inv.applied_amount = '';
          }
        }
      }
      if (Array.isArray(this.vm?.applied)) {
        for (const app of this.vm.applied) {
          if (app) {
            app.applied_amount = '';
          }
        }
      }
      // Recalculate totals and leave header amount untouched
      this.calcTotals();
    } catch {
      // keep UX resilient
    }
  }

  /**
   * Compute whether Print and Email buttons should be enabled based on the rules:
   * - If paymentId is 'newAP' or 'newAR': disable both Print and Email until saved.
   * - For AP payments (batchType=5 or subLedger='ap') with a real id: enable Print only when
   *   applied amount equals payment amount (fully applied) and both are > 0.
   * - Email is enabled whenever the entry is saved (id not 'newAP'/'newAR').
   *   Additional email gating rules can be added later if needed.
   */
  private updateHeaderButtonStates() {
    const pid = String(this.paymentId || this.vm?.item?.header?.id || '').toLowerCase();
    const isNew = pid === 'newap' || pid === 'newar' || this.paymentId === 'newAP' || this.paymentId === 'newAR';
    // Default: disable both when new/unsaved
    if (isNew) {
      this.printDisabled = true;
      this.emailDisabled = true;
      return;
    }

    // Saved entry: email allowed by default
    this.emailDisabled = false;

    // Determine ledger type
    const sub = String(this.vm?.subLedger || this.vm?.type || '').toLowerCase();
    const isAP = sub === 'ap' || String(this.vm?.item?.batch?.type_id) === '5';
    if (isAP) {
      const totalApplied = Math.abs(Number(this.vm?.totalPaid || 0));
      const paymentAmt = Math.abs(Number(this.vm?.item?.header?.detail_total || 0));
      // Enable print only if fully applied and positive
      this.printDisabled = !(totalApplied > 0 && paymentAmt > 0 && totalApplied === paymentAmt);
    } else {
      // AR: print is allowed when saved; additional AR rules handled inside print() itself
      this.printDisabled = false;
    }
  }

  checkForRefund() {
    // Do not run refund detection for AR payments
    try {
      if (String(this.vm?.item?.batch?.type_id) === String(BATCH_TYPE_AR)) {
        return false;
      }
    } catch {
      // if batch not available, fall through to existing behavior
    }
    this.vm.isRefund = false;
    if (this.isPaymentTypeCheck() || this.isStripePaymentTypeSelected()) {
      return false;
    }
    const isPossibleRefund = this.vm.entity.find((x) => x.id === this.vm.item.header.entity_id).receivable;
    if (Number(this.vm?.item?.header?.detail_total || 0) < 0 && isPossibleRefund) {
      // console.log('refund');
      this.vm.isRefund = true;
      this.vm.subLedger = SUBLEDGER_AR;
      this.vm.isRefund = true;
      return true;
    } else {
      return false;
    }
  }

  removeComma() {
    if (
      !Number(this.vm.item.header.detail_total) &&
      this.vm.item.header.detail_total &&
      this.vm.item.header.detail_total !== '-' &&
      this.vm.item.header.detail_total !== '0'
    ) {
      let tempAmount = this.vm.item.header.detail_total;
      tempAmount = tempAmount.replace(',', '');
      if (Number(tempAmount)) {
        this.vm.item.header.detail_total = tempAmount;
      } else {
        this.vm.item.header.detail_total = '';
      }
    }
    // After normalizing the Amount input, keep detail amounts in sync as positive quantities
    this.syncDetailAmountsFromHeader();
  }

  /**
   * Amount input change handler (AP side).
   * - If Refund mode is selected, force the displayed amount to be negative while using abs() for calculations.
   * - If not Refund, strip any '-' so only positive values are accepted.
   */
  onAmountChange(raw: any): void {
    try {
      const str = (raw ?? '').toString().split(',').join('');
      let num = Number(str);
      if (!isFinite(num)) {
        num = 0;
      }
      if (this.vm?.isRefund) {
        // Display as negative; use abs magnitude for internal math elsewhere
        this.vm.item.header.detail_total = -Math.abs(num);
      } else {
        // Enforce non-negative when not refund
        this.vm.item.header.detail_total = Math.abs(num);
      }
      this.vm.manualAmount = true;
      this.syncDetailAmountsFromHeader();
      // Do not auto-apply here; let user click Apply or Pay All
      this.updateHeaderButtonStates();
    } catch {
      // no-op
    }
  }

  apply() {
    this.vm.invoices = this.OrderBy(this.vm.invoices, 'header_date', false);

    // Unified allocation behavior. Only difference for Refund: use abs(header) as remaining.
    let remaining = Math.round((this.vm.isRefund
      ? Math.abs(Number(this.vm.item?.header?.detail_total || 0))
      : Number(this.vm.item?.header?.detail_total || 0)) * 100) / 100;

    // Clear existing per-row applied amounts
    for (const invoice of this.vm.invoices) {
      invoice.applied_amount = '';
    }
    for (const a of this.vm.applied) {
      a.applied_amount = '';
    }

    const computeOwing = (row: any): number => {
      const owingStandard = Math.round(((Number(row.detail_total || 0) - Number(row.payment_applied_total || 0))) * 100) / 100;
      let owing = Math.max(0, owingStandard);
      if (this.vm.isRefund) {
        // In refund mode, credits may present as negative owing or via payment_applied_total.
        // Prefer any available credit magnitude when standard owing is not positive.
        const creditAvail = Math.max(0, Number(row.payment_applied_total || 0));
        if (owing <= 0 && creditAvail > 0) {
          owing = creditAvail;
        }
      }
      return Math.round(owing * 100) / 100;
    };

    // First pass: rows already in applied list
    for (const obj of this.vm.applied) {
      if (remaining <= 0) {
        break;
      }
      const owing = computeOwing(obj);
      if (owing <= 0) {
        continue;
      }
      const take = Math.min(remaining, owing);
      obj.applied_amount = take;
      remaining = Math.round((remaining - take) * 100) / 100;
    }

    // Second pass: remaining invoices list
    if (remaining > 0) {
      for (const obj of this.vm.invoices) {
        if (remaining <= 0) {
          break;
        }
        const owing = computeOwing(obj);
        if (owing <= 0) {
          continue;
        }
        const take = Math.min(remaining, owing);
        obj.applied_amount = take;
        remaining = Math.round((remaining - take) * 100) / 100;
      }
    }

    this.calcTotals();
  }

  buildApplied() {
    this.vm.item.applied = [];
    for (const obj of this.vm.applied) {
      if (Math.abs(Number(obj.applied_amount)) > 0) {
        this.vm.item.applied.push({
          applied_header_id: obj.applied_header_id,
          applied_amount: Math.abs(Number(obj.applied_amount)),
          applied_date: obj.header_date,
          // Include the document number so the receipt print can show it in the Reference column
          number: obj.number
        });
      }
    }
    if (this.vm.invoices) {
      for (const obj of this.vm.invoices) {
        // Use Math.abs — credit memo rows have negative applied_amount after calcTotals but must
        // be sent to the API as positive magnitude (API uses the document's own sign convention)
        if (Math.abs(Number(obj.applied_amount)) > 0) {
          this.vm.item.applied.push({
            applied_header_id: obj.id,
            applied_amount: Math.abs(Number(obj.applied_amount)),
            applied_date: obj.header_date,
            // Include the document number so the receipt print can show it in the Reference column
            number: obj.number
          });
        }
      }
    }
    // applied_amount is always sent as positive — API handles sign convention for both AR and AP
    if (!this.vm.item.detail[0].account_id) {
      this.vm.item.detail[0].account_id = this.FilterObject(
        this.vm.bank,
        { id: this.vm.item.header.bank_id },
        true
      )[0].account_id;
    }
  }

  // ACTIONS

  async print() {
    if (this.vm.action !== 'email') {
      this.vm.action = 'print';
    }
    // Double-click guard
    if (this._printingReceipt) {
      return;
    }
    this._printingReceipt = true;

    // Build the applied array on the item from current selections so totals are accurate
    try {
      this.buildApplied();
    } catch {
    }
    try {
      this.calcTotals();
    } catch {
    }

    const isAP = (String(this.vm?.subLedger).toLowerCase() === 'ap') || (String(this.vm?.item?.batch?.type_id) === '5');
    const totalPaidNow = Math.abs(Number(this.vm?.totalPaid || 0));
    const paymentAmountAbs = Math.abs(Number(this.vm?.item?.detail?.[0]?.amount || 0));

    // Only enforce the "no payments" receipt rule for AR; AP prints a Paid Check copy regardless
    // Allow special edge-case for AR: payment amount == 0 AND sum of applied items == 0
    const allowZeroReceiptAR = (!isAP) && (paymentAmountAbs === 0) && (totalPaidNow === 0);
    if (!isAP && (!totalPaidNow || totalPaidNow < 0) && !allowZeroReceiptAR) {
      this.notification.showWarningToast($localize`:No payments made - no receipt available@@noPaymentsNoReceipt:No payments made - no receipt available`);
      this.vm.action = '';
      this._printingReceipt = false;
      return;
    }

    // AP check print criteria (form):
    // - If fully applied (payment == applied): print PAID watermark copy via iframe (do NOT trigger preview component)
    // - If there is an unapplied amount (payment > applied and applied > 0): trigger REAL CHECK preview (payment-print component)
    // - If none applied or over-applied: warn and abort
    if (isAP) {
      if (totalPaidNow <= 0) {
        this.notification.showWarningToast($localize`:No applied invoices - cannot print check@@noAppliedCannotPrint:No applied invoices - cannot print check`);
        this.vm.action = '';
        this._printingReceipt = false;
        return;
      }
      // Over-applied check
      if (totalPaidNow > paymentAmountAbs) {
        this.notification.showWarningToast($localize`:Payment exceeds amount - cannot print check@@paymentOverAppliedCannotPrint:Payment exceeds amount - cannot print check`);
        this.vm.action = '';
        this._printingReceipt = false;
        return;
      }
      // If there is an unapplied amount (partial application), route to REAL CHECK preview and do not print PAID copy here
      if (paymentAmountAbs > totalPaidNow) {
        // Prepare preview data for payment-print component
        if (!this.vm.entityAddress || this.vm.entityAddress.length < 1) {
          this.notification.showWarningToast(
            $localize`:No printable addresses for this Entity @@noprintaddresses:No printable addresses for this Entity`
          );
          this.vm.action = '';
          this._printingReceipt = false;
          return;
        }
        // Ensure preview flags and data are populated; vm.check is assembled below
        this.vm.confirmPrint = true;
        this._printingReceipt = false;
        // Keep going so vm.check is built below, but DO NOT execute the PAID copy iframe branch
      }
      // For fully applied (payment == applied), validate payee address before printing PAID copy
      if (!this.vm.entityAddress || this.vm.entityAddress.length < 1) {
        this.notification.showWarningToast(
          $localize`:No printable addresses for this Entity @@noprintaddresses:No printable addresses for this Entity`
        );
        this.vm.action = '';
        this._printingReceipt = false;
        return;
      }
    }

    if (this.vm.entityAddress.length < 1) {
      this.notification.showWarningToast(
        $localize`:No printable addresses for this Entity @@noprintaddresses:No printable addresses for this Entity`
      );
      this.vm.action = '';
      this._printingReceipt = false;
      return;
    }

    let tempEntityAddress1 = '';
    let tempEntityAddress2 = '';
    let tempEntityAddress3 = '';
    let tempCompanyAddress2 = '';
    let tempBankAddress2 = '';
    const tempCompany: any = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0];
    const tempBank: any = this.FilterObject(this.vm.bank, { id: this.vm.item.header.bank_id }, true)[0];
    const tempCheckStock = this.FilterObject(this.vm.checkStock, { id: tempBank.stock_id }, true)[0];
    this.vm.stub = [{ id: 1 }, { id: 2 }];
    if (tempBank.stock_id) {
      this.vm.printLayout.checkStock = this.FilterObject(this.vm.checkStock, { id: tempBank.stock_id }, true)[0];
    }
    // console.log('address in print: ' + JSON.stringify(this.vm.entityAddress));
    tempEntityAddress1 = this.vm.entityAddress[0].address_1;
    tempEntityAddress2 = this.vm.entityAddress[0].address_2;
    tempEntityAddress3 =
      this.vm.entityAddress[0].city + ', ' + this.vm.entityAddress[0].state + ' ' + this.vm.entityAddress[0].zip;
    if (tempCompany.city && (tempCompany.state || tempCompany.zip)) {
      tempCompanyAddress2 = tempCompany.city + ', ' + tempCompany.state + ' ' + tempCompany.zip;
    } else if (tempCompany.city) {
      tempCompanyAddress2 = tempCompany.city;
    } else {
      tempCompanyAddress2 = tempCompany.state + ' ' + tempCompany.zip;
    }
    if (tempBank.city && (tempBank.state || tempBank.zip)) {
      tempBankAddress2 = tempBank.city + ', ' + tempBank.state + ' ' + tempBank.zip;
    } else if (tempBank.city) {
      tempBankAddress2 = tempBank.city;
    } else {
      tempBankAddress2 = tempBank.state + ' ' + tempBank.zip;
    }

    // Ensure totals reflect current applied amounts before computing check amount
    try {
      this.calcTotals();
    } catch {
    }
    // The check amount must equal the sum of applied payments for this payment transaction
    let tempAmount = Number(this.vm?.totalPaid || 0);

    // For refunds (negative payment entry), display positive value on the check face
    if (Number(this.vm?.item?.detail?.[0]?.amount) < 0 && tempAmount > 0) {
      tempAmount = tempAmount * -1; // mirror original sign logic first
    }
    // Always print the absolute value on the check amount
    tempAmount = Math.abs(tempAmount);
    const tempAmountInWords = this.words.convert(tempAmount, { currency: true });

    this.vm.check = [
      {
        companyName: tempCompany.name,
        companyDBA: tempCompany.dba,
        companyAddress1: tempCompany.address_1,
        companyAddress2: tempCompanyAddress2,
        companyPhone: tempCompany.phone,
        bankName: tempBank.check_name,
        bankAddress1: tempBank.address_1,
        bankAddress2: tempBankAddress2,
        bankPhone: tempBank.phone,
        payeeName: this.vm.item.header.entityInput,
        payeeAddress1: tempEntityAddress1,
        payeeAddress2: tempEntityAddress2,
        payeeAddress3: tempEntityAddress3,
        accountNumber: tempBank.account_number,
        transitNumber: tempBank.transit_number,
        institutionNumber: tempBank.institution_number,
        number: this.vm.item.header.number,
        amountInWords: tempAmountInWords,
        // Amount equals sum of applied payments for this transaction
        amount: tempAmount,
        date: this.vm.item.header.header_date,
      },
    ];

    // After preparing data, route printing through shared iframe flow.
    try {
      if (isAP) {
        // If partial application (preview path), do not print here; leave preview visible
        if (paymentAmountAbs > totalPaidNow) {
          // Ensure we do not trigger iframe print and leave preview data in place
          this.vm.action = '';
          return;
        }
        // AP printed==true: print Check Paid Copy using payment-print layout basis
        const paymentAmount = Math.abs(Number(this.vm?.item?.detail?.[0]?.amount || 0));
        const totalPaid = Math.abs(Number(this.vm?.totalPaid || 0));
        // Also attach applied list to the first check for stub rendering (enriched with number/header_date)
        let enrichedApplied: any[] = [];
        try {
          const appliedSrc = Array.isArray(this.vm?.item?.applied) ? this.vm.item.applied : [];
          const invs = Array.isArray(this.vm?.invoices) ? this.vm.invoices : [];
          const invMap: Record<string, any> = {};
          invs.forEach((it: any) => {
            invMap[String(it?.id)] = it;
          });
          enrichedApplied = appliedSrc.map((a: any) => {
            const inv = invMap[String(a?.applied_header_id)] || {};
            return {
              ...a,
              number: (a?.number ?? inv?.number ?? a?.applied_header_id),
              header_date: (a?.header_date ?? a?.applied_date ?? inv?.header_date),
            };
          });
        } catch {
          enrichedApplied = Array.isArray(this.vm?.item?.applied) ? this.vm.item.applied : [];
        }
        if (Array.isArray(this.vm?.check) && this.vm.check.length) {
          this.vm.check[0].applied = enrichedApplied;
          this.vm.check[0].paymentAmount = paymentAmount;
          this.vm.check[0].totalPaid = totalPaid;
        }
        const apVm: any = {
          check: this.vm?.check || [],
          printLayout: {checkStock: this.vm?.printLayout?.checkStock || {}},
          applied: enrichedApplied,
          paymentAmount,
          totalPaid,
        };
        const html = this.paymentDoc.buildApCheckHtml(apVm);
        await this.paymentDoc.printHtml(html);
      } else {
        // AR: print Receipt (no preview scrolling, no confirm buttons)
        const mappedVm: any = {
          item: {
            header: this.vm?.item?.header || {},
            detail: Array.isArray(this.vm?.item?.detail) ? this.vm.item.detail : [],
            applied: Array.isArray(this.vm?.item?.applied) ? this.vm.item.applied : [],
          },
          company: this.vm?.company,
          billToAddress: this.vm?.entityAddress,
          shipToAddress: this.vm?.entityAddress,
          subLedger: this.vm?.subLedger || this.vm?.type || 'ar',
          type: this.vm?.subLedger || this.vm?.type || 'ar',
          // Provide totals for receipt display
          totals: {
            originalOwed: this.vm?.totalOwing,
            paymentAmount: Math.abs(Number(this.vm?.item?.detail?.[0]?.amount || 0)),
            totalApplied: Math.abs(Number(this.vm?.totalPaid || 0)),
          },
        };
        const html = this.paymentDoc.buildPrintHtml(mappedVm, 'receipt');
        await this.paymentDoc.printHtml(html);
      }
      // Only show preview/confirm for AP partial paths; AR receipt should not toggle preview UI
      if (isAP) {
        // For watermark path, ensure preview is disabled
        if (paymentAmountAbs === totalPaidNow) {
          this.vm.confirmPrint = false;
        }
      } else {
        this.vm.confirmPrint = false;
      }
      this.vm.action = '';
      return;
    } catch (e) {
      console.error('Payment print failed', e);
      this.notification.showErrorToast($localize`:Unable to print document@@unableToPrint:Unable to print document`);
      // Fall through to legacy path only if needed
    }

    // console.log('check to print: ' + JSON.stringify(this.vm.check));
    if (this.vm.item.batch.locked !== 1) {
      if (this.action === 'print') {
        this.vm.confirmPrint = true;
        this.action = '';
        const z = setTimeout(
          function doPrint() {
            clearTimeout(z);
            window.print();
            this.vm.confirmPrint = true;
          }.bind(this),
          1500
        );
        this.vm.action = '';
      } else if (this.action === 'email') {
        this.action = '';
        this.vm.confirmPrint = false;
        const z = setTimeout(
          function doEmail() {
            clearTimeout(z);
            // this.sendEmail();
          }.bind(this),
          1500
        );
        this.vm.action = '';
      }
    } else if (this.vm.action === 'print') {
      const z = setTimeout(
        function doPrint() {
          clearTimeout(z);
          window.print();
          this.vm.confirmPrint = true;
        }.bind(this),
        1500
      );
      this.vm.action = '';
    } else if (this.vm.action === 'email') {
      this.vm.confirmPrint = false;
      const z = setTimeout(
        function doEmail() {
          clearTimeout(z);
          // this.sendEmail();
        }.bind(this),
        1500
      );
      this.vm.action = '';
    }
    this.vm.confirmPrint = true;
  }


  email() {
    this.vm.action = 'email';
    // prepare printable data (vm.check, vm.stub, etc.)
    // this.print();
    this.emailDocument();
  }

  emailDocument() {
    this.setEmailData();

    // Show the shared Send Email modal directly
    //   const element = document.getElementById('sendEmailModal') as HTMLElement;
    //   if (element) {
    //     const emailModal = new Modal(element);
    //     emailModal.show();
    //   }
  }

  setEmailData() {
    // Determine document name based on subledger
    const compVal = this.vm.subLedger;
    switch (compVal) {
      case SUBLEDGER_AP:
        this.emailDocumentName = 'Payment Check';
        break;
      case SUBLEDGER_AR:
        this.emailDocumentName = 'Payment Receipt';
        break;
      default:
        this.emailDocumentName = 'Payment';
        break;
    }

    const emailDocObj = {} as EmailModel;

    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = this.vm?.item?.header?.id;
    emailDocObj.entity_id = this.vm?.item?.header?.entity_id;
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + this.emailDocumentName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + this.emailDocumentName;

    // Build the email HTML using the same renderer used for printing receipts
    // so emailed receipt matches the printed receipt exactly.
    try {
      // Ensure vm.item.applied and totals reflect current selections
      this.buildApplied();
      this.calcTotals();
      // Use the receipt template for AR (receipts). For AP we retain existing behavior for now.
      if (compVal === SUBLEDGER_AR) {
        emailDocObj.pdfHtml = this.printBuilder.buildEmailHtml(this.vm, 'receipt');
      } else {
        // Fallback: attempt to capture any on-screen report-html if present
        this.changeDetect.detectChanges();
        const el = document.getElementById('report-html');
        emailDocObj.pdfHtml = el ? el.innerHTML : '';
      }
    } catch {
      emailDocObj.pdfHtml = '';
    }
    emailDocObj.activity_message = this.emailDocumentName;

    // Provide a deterministic file name for the attachment if generated
    const safeName = (this.emailDocumentName || 'document').replace(/\s+/g, '_');
    const id = this.vm?.item?.header?.id;
    if (id != null) {
      emailDocObj.FileName = `${safeName}_${id}.pdf`;
    } else {
      emailDocObj.FileName = `${safeName}.pdf`;
    }

    this.reportDataToSendInEmail = emailDocObj;
  }

  onClose() {
    const previousUrl = this.prevUrl.getPreviousUrl() || this.routedFrom;
    if (previousUrl && !previousUrl.includes('/transactions/payment/form')) {
      this.router.navigateByUrl(previousUrl).then();
      return;
    }

    // No meaningful previous in-app URL (likely opened from an external link/new tab)
    // Try to close the tab/window first; if the browser blocks it, fall back to list navigation
    try {
      window.close();
    } catch {
      // ignored — proceed to fallback navigation
    }
    this.router.navigateByUrl(this.getPaymentListFallbackUrl()).then();
  }

  private getPaymentListFallbackUrl(): string {
    const paymentIdToken = String(this.paymentId || '').toLowerCase();
    const subLedger = String(this.vm?.subLedger || '').toLowerCase();
    const isAp = subLedger === SUBLEDGER_AP || paymentIdToken === 'newap';

    return isAp
      ? '/transactions/payment/list/ap?type=ap&subLedger=ap'
      : '/transactions/payment/list/ar?type=ar&subLedger=ar';
  }

  private getSelectedPaymentTypeConfig(): any {
    const paymentTypeId = this.vm?.item?.header?.payment_type_id;
    if (!paymentTypeId || !Array.isArray(this.vm?.paymentType)) {
      return null;
    }

    return this.vm.paymentType.find((x: any) => String(x?.id) === String(paymentTypeId)) || null;
  }

  private getPaymentTypeFlag(paymentType: any, ...keys: string[]): any {
    if (!paymentType) {
      return null;
    }

    for (const key of keys) {
      if (paymentType[key] !== undefined && paymentType[key] !== null) {
        return paymentType[key];
      }
      const pascal = key.charAt(0).toUpperCase() + key.slice(1);
      if (paymentType[pascal] !== undefined && paymentType[pascal] !== null) {
        return paymentType[pascal];
      }

      const isPascal = `Is${pascal}`;
      if (paymentType[isPascal] !== undefined && paymentType[isPascal] !== null) {
        return paymentType[isPascal];
      }

      const noUnderscore = key.replace(/_/g, '');
      const noUnderscorePascal = noUnderscore.charAt(0).toUpperCase() + noUnderscore.slice(1);
      if (paymentType[noUnderscore] !== undefined && paymentType[noUnderscore] !== null) {
        return paymentType[noUnderscore];
      }
      if (paymentType[noUnderscorePascal] !== undefined && paymentType[noUnderscorePascal] !== null) {
        return paymentType[noUnderscorePascal];
      }
      const isNoUnderscorePascal = `Is${noUnderscorePascal}`;
      if (paymentType[isNoUnderscorePascal] !== undefined && paymentType[isNoUnderscorePascal] !== null) {
        return paymentType[isNoUnderscorePascal];
      }
    }

    return null;
  }

  isPaymentTypeCheck(): boolean {
    const paymentType = this.getSelectedPaymentTypeConfig();
    if (!paymentType) {
      return false;
    }
    const isTruthy = (v: any) => v === true || v === 1 || String(v ?? '').trim().toLowerCase() === 'true' || String(v ?? '').trim() === '1';
    return isTruthy(paymentType.print_check) && isTruthy(paymentType.active);
  }

  protected isStripePaymentTypeSelected(): boolean {
    const paymentType = this.getSelectedPaymentTypeConfig();
    if (!paymentType) {
      return false;
    }

    return this.isStripePaymentType(paymentType);
  }

  private isStripePaymentType(paymentType: any): boolean {
    if (!paymentType) {
      return false;
    }
    // Identify Stripe payment types by common flags/fields on the payment type record.
    // We consider it Stripe when one of the known indicators is truthy AND the type is active.
    const stripeEnabled =
      this.getPaymentTypeFlag(paymentType, 'stripe_enabled', 'stripeEnabled')
      ?? this.getPaymentTypeFlag(paymentType, 'is_stripe', 'isStripe');

    const processor = (this.getPaymentTypeFlag(paymentType, 'processor', 'paymentProcessor') || '').toString().trim().toLowerCase();
    const code = (this.getPaymentTypeFlag(paymentType, 'code', 'typeCode') || '').toString().trim().toLowerCase();
    const name = (this.getPaymentTypeFlag(paymentType, 'name', 'displayName') || '').toString().trim().toLowerCase();

    const isProcessorStripe = processor === 'stripe';
    const isCodeStripe = code === 'stripe' || code === 'strp' || code === 'stripe_ach';
    const isNameStripe = name.includes('stripe');

    const active = this.getPaymentTypeFlag(paymentType, 'active', 'isActive');
    const isTruthy = (v: any) => {
      const s = String(v ?? '').trim().toLowerCase();
      return v === true || v === 1 || s === '1' || s === 'true' || s === 'yes' || s === 'y';
    };
    const looksStripe = isTruthy(stripeEnabled) || isProcessorStripe || isCodeStripe || isNameStripe;
    return looksStripe && isTruthy(active);
  }

  private async fetchStripeSetupForEntity(appEntityId: string): Promise<void> {
    try {
      const setup = await lastValueFrom(this.stripePaymentService.getStripeSetup(appEntityId));
      this.stripeSetup = setup?.Data || setup || null;
      this.applyStripePaymentTypeFilterForCurrentEntity();
    } catch (e) {
      this.stripeSetup = null;
      this.applyStripePaymentTypeFilterForCurrentEntity();
      console.warn('[Payment Form] Failed to fetch Stripe setup for entity', appEntityId, e);
    }
  }

  private async loadStripeSetupForEntityIfStripeType(): Promise<void> {
    if (!this.isStripePaymentTypeSelected()) {
      return;
    }
    try {
      const appEntityId = String(this.vm?.item?.header?.entity_id || '').trim();
      if (!appEntityId) {
        this.stripeSetup = null;
        this.applyStripePaymentTypeFilterForCurrentEntity();
        return;
      }
      await this.fetchStripeSetupForEntity(appEntityId);
    } catch {
      // no-op
    }
  }

  isStripePaymentTypeUiSelected(): boolean {
    return this.isStripePaymentTypeSelected();
  }

  isSavedStripePayment(): boolean {
    return this.isStripePaymentTypeSelected() && this.isExistingPayment();
  }

  isPaymentNumberRequired(): boolean {
    if (this.isStripePaymentTypeSelected()) {
      return false;
    }
    if (this.isPaymentTypeCheck()) {
      return false;
    }
    return true;
  }

  private getStripeEntityTypeCode(rawEntityType: any): number | null {
    if (rawEntityType === null || rawEntityType === undefined) {
      return null;
    }

    const asNumber = Number(rawEntityType);
    if (asNumber === 1 || asNumber === 2) {
      return asNumber;
    }

    const normalized = String(rawEntityType).trim().toLowerCase();
    if (normalized === 'customer') {
      return 1;
    }

    if (normalized === 'vendor') {
      return 2;
    }

    return null;
  }

  onPaymentTypeChanged(_value: any): void {
    // No filtering here; filtering is applied on entity change only per requirement
    this.computePaymentMode();
    // Assign check number from bank only when switching TO check type; clear otherwise
    if (this.isPaymentTypeCheck()) {
      // Number is auto-assigned on print; do not pre-populate here
    } else {
      this.vm.item.header.number = '';
    }
  }

  // PHASE 3 — Compute the single PaymentMode from current vm state.
  // Called after load, after payment type change, and after payable type change.
  computePaymentMode(): void {
    try {
      const batchTypeId = Number(this.vm?.item?.batch?.type_id || this.vm?.item?.batchTypeId || 0);
      const isAP = batchTypeId === BATCH_TYPE_AP;
      const isRefund = !!this.vm?.isRefund;

      if (isRefund) {
        this.paymentMode = isAP ? PaymentMode.AP_REFUND : PaymentMode.AR_REFUND;
        return;
      }

      if (!isAP) {
        this.paymentMode = PaymentMode.AR;
        return;
      }

      // AP — determine sub-type from payment type config
      if (this.isStripePaymentTypeSelected()) {
        this.paymentMode = PaymentMode.AP_STRIPE;
      } else if (this.isPaymentTypeCheck()) {
        this.paymentMode = PaymentMode.AP_CHECK;
      } else {
        this.paymentMode = PaymentMode.AP_OTHER;
      }
    } catch {
      // keep UI resilient
    }
  }

  // Convenience helpers — delegate to paymentMode for clean template usage
  isApMode(): boolean {
    return this.paymentMode === PaymentMode.AP_CHECK
      || this.paymentMode === PaymentMode.AP_STRIPE
      || this.paymentMode === PaymentMode.AP_OTHER
      || this.paymentMode === PaymentMode.AP_REFUND;
  }

  isRefundMode(): boolean {
    return this.paymentMode === PaymentMode.AR_REFUND
      || this.paymentMode === PaymentMode.AP_REFUND;
  }

  private resolveStripeEntityTypeCodeForPayment(): number {
    const batchTypeId = String(this.vm?.item?.batch?.type_id || '');
    if (batchTypeId === String(BATCH_TYPE_AR)) {
      return 1;
    }
    if (batchTypeId === String(BATCH_TYPE_AP)) {
      return 2;
    }

    const fromItem = this.getStripeEntityTypeCode(this.vm?.item?.entity?.entity_type);
    if (fromItem) {
      return fromItem;
    }

    const fromSelected = this.getStripeEntityTypeCode(this.vm?.selectedEntityType);
    if (fromSelected) {
      return fromSelected;
    }

    const subLedger = String(this.vm?.subLedger || '').toLowerCase();
    return subLedger === SUBLEDGER_AP ? 2 : 1;
  }

  private resolveStripePaymentMethodIdFromResponse(methods: any[]): string | null {
    if (!Array.isArray(methods) || methods.length === 0) {
      return null;
    }

    const candidates: any[] = [];
    for (const method of methods) {
      candidates.push(method);

      const nested = method?.paymentMethods || method?.PaymentMethods || method?.payment_methods || method?.data || method?.Data;
      if (Array.isArray(nested)) {
        candidates.push(...nested);
      }
    }

    for (const candidate of candidates) {
      const paymentMethodId =
        candidate?.paymentMethodId ||
        candidate?.payment_method_id ||
        candidate?.stripePaymentMethodId ||
        candidate?.StripePaymentMethodId ||
        candidate?.id ||
        candidate?.Id ||
        candidate?.payment_method ||
        null;

      if (paymentMethodId) {
        return String(paymentMethodId);
      }
    }

    return null;
  }

  private extractPendingSetupCount(methods: any[]): number {
    if (!Array.isArray(methods) || methods.length === 0) {
      return 0;
    }

    let count = 0;
    for (const method of methods) {
      const pending = method?.PendingSetups || method?.pendingSetups || method?.pending_setups || method?.Data?.PendingSetups;
      if (Array.isArray(pending)) {
        count += pending.length;
      }
    }
    return count;
  }

  private setStripeSetupStatus(status: 'pending' | 'verified' | null, message = ''): void {
    this.stripeSetupStatus = status;
    this.stripeSetupStatusMessage = message;
  }

  // ── STRIPE REGION ─────────────────────────────────────────────────────────
  // All Stripe-specific logic lives below this line.
  // HTML-referenced: isStripePaymentTypeUiSelected, getStripeTransactionStatus*,
  //   canRefreshStripeStatus, onRefreshStripeStatusCurrentPayment, stripeCancelLoading,
  //   stripeSaveProcessing, stripeApIsCancellable, isStripePaymentTypeSelected.
  // Internal: all other methods below.
  // ─────────────────────────────────────────────────────────────────────────
  private stripeSetup: any = null;

  private computeStripeAchVerified(setup: any): boolean {
    if (!setup) {
      return false;
    }
    const norm = (v: any) => String(v ?? '').trim().toLowerCase();
    const flow = this.getCurrentFlow();
    const arStatus = norm(setup?.Ar?.AchStatus);
    const apStatus = norm(setup?.Ap?.AchStatus);
    if (flow === 'AR') {
      return arStatus === 'verified';
    }
    // AP flow
    return apStatus === 'verified';
  }

  private getCurrentFlow(): 'AR' | 'AP' {
    try {
      // 1) Trust the subledger first (authoritative for this screen)
      const sub = (this.vm?.subLedger || '').toString().toLowerCase();
      if (sub === SUBLEDGER_AP) {
        return 'AP';
      }
      if (sub === SUBLEDGER_AR) {
        return 'AR';
      }

      // 2) Fallback to batch type when available
      const typeId = Number(this.vm?.item?.batch?.type_id);
      if (typeId === BATCH_TYPE_AP) {
        return 'AP';
      }
      if (typeId === BATCH_TYPE_AR) {
        return 'AR';
      }

      // 3) Final fallback: default to AR (legacy default) when no explicit signals are present
      return 'AR';
    } catch {
      // Safe default
      return 'AR';
    }
  }

  // Resolve a currency code from the app currency list by id (best-effort, safe fallbacks)
  private getCurrencyCodeById(currencyId: any): string {
    try {
      const id = String(currencyId ?? '').trim();
      if (!id) {
        return '';
      }
      const list: any[] = Array.isArray(this.vm?.currency) ? this.vm.currency : [];
      const found = list.find((c: any) => String(c?.id) === id);
      const code = (found?.code ?? found?.Code ?? found?.currency_code ?? found?.CurrencyCode ?? '').toString().trim();
      return code || '';
    } catch {
      return '';
    }
  }

  // Simple, KISS: for save-time gating of Stripe flow
  private async ensureStripeVerifiedForCurrentFlow(): Promise<boolean> {
    if (!this.isStripePaymentTypeSelected()) {
      return true; // not a Stripe payment
    }
    const entityId = String(this.vm?.item?.header?.entity_id || '').trim();
    if (!entityId) {
      this.notification.showWarningToast('Entity is required before Stripe payment can continue.');
      return false;
    }
    // If we don't have setup loaded (or it's from a different entity), fetch it now
    const hasSetupForEntity = !!this.stripeSetup && (String(this.stripeSetup?.Global?.AppEntityId || this.stripeSetup?.appEntityId || this.vm?.item?.header?.entity_id).toString().trim() === entityId);
    if (!hasSetupForEntity) {
      await this.fetchStripeSetupForEntity(entityId);
    }
    const verified = this.computeStripeAchVerified(this.stripeSetup);
    if (!verified) {
      this.notification.showWarningToast('Cannot save: Stripe ACH for this entity is not verified for this flow. Complete setup in Stripe Admin or choose a different Payment Type.');
      return false;
    }
    return true;
  }

  // Single, simple filtering method: checks payment type flags and current entity's AchStatus for flow
  private applyStripePaymentTypeFilterForCurrentEntity(): void {
    const all: any[] = Array.isArray(this.vm?.paymentType) ? this.vm.paymentType : [];
    const hasEntity = Boolean(String(this.vm?.item?.header?.entity_id || '').trim());
    // If no entity selected, do not filter at all
    if (!hasEntity) {
      (this.vm as any).filteredPaymentType = undefined as any;
      return;
    }

    const isVerifiedForFlow = this.isEntityVerifiedForFlow();
    const filtered = all.filter((pt: any) => {
      const isStripe = this.isStripePaymentType(pt);
      // hide Stripe unless verified for the current flow; retain all non-Stripe
      return !isStripe || isVerifiedForFlow;
    });
    (this.vm as any).filteredPaymentType = filtered;
  }

  isStripeSelectedButNotVerified(): boolean {
    try {
      const selected = this.getSelectedPaymentTypeConfig();
      return Boolean(selected) && this.isStripePaymentType(selected) && !this.isEntityVerifiedForFlow();
    } catch {
      return false;
    }
  }

  // ---- KISS helpers (no cached booleans) ----
  private isStripeTypeSelected(): boolean {
    const selected = this.getSelectedPaymentTypeConfig();
    return !!selected && this.isStripePaymentType(selected);
  }

  private isEntityVerifiedForFlow(): boolean {
    // Uses current this.stripeSetup; if not loaded or null, treat as not verified
    return this.computeStripeAchVerified(this.stripeSetup);
  }

  private isStripeAllowedForCurrentFlow(): boolean {
    return this.isStripeTypeSelected() && this.isEntityVerifiedForFlow();
  }

  private buildStripeIntentPayload(appTransactionId?: string | number | null): any | null {
    try {
      const header = this.vm?.item?.header || {};
      const appEntityId = String(header?.entity_id || '').trim();
      const appBankId = String(header?.bank_id || '').trim();
      if (!appEntityId || !appBankId) {
        return null; // insufficient data
      }

      // Flow mapping
      const isAr = this.getCurrentFlow() === 'AR';
      const stripeFlowType = isAr ? 1 : 2; // 1=Customer(AR), 2=Vendor(AP)
      const direction = isAr ? 1 : 2;     // 1=Collect, 2=Payout
      const flowType = isAr ? 1 : 2;      // 1=AchDebit, 2=AchPayout

      // Amount & currency
      const amount = Math.abs(Number(header?.detail_total || 0));
      let currency = 'usd';
      try {
        const curId = String(header?.currency_id || '');
        const cur = Array.isArray(this.vm?.currency) ? this.vm.currency.find((c: any) => String(c?.id) === curId) : null;
        currency = (cur?.code || cur?.symbol || cur?.name || 'usd').toString().toLowerCase();
      } catch {
      }

      // Payment method id from Stripe setup (per flow) if present
      const pmId = isAr ? (this.stripeSetup?.Ar?.DefaultPaymentMethodId || this.stripeSetup?.Ar?.PaymentMethodId)
        : (this.stripeSetup?.Ap?.DefaultPaymentMethodId || this.stripeSetup?.Ap?.PaymentMethodId);

      // Reference: prefer payment number; optionally fall back to first applied document number
      let referenceId = header?.number || null;
      try {
        if (!referenceId && Array.isArray(this.vm?.item?.applied) && this.vm.item.applied.length > 0) {
          referenceId = this.vm.item.applied[0]?.document_number || this.vm.item.applied[0]?.number || null;
        }
      } catch {
      }

      const payload: any = {
        appEntityId,
        appBankId,
        stripeFlowType,
        direction,
        flowType,
        amount,
        currency,
        confirmImmediately: true,
      };
      if (pmId) {
        payload.paymentMethodId = pmId;
      }
      if (referenceId) {
        payload.referenceId = String(referenceId);
      }
      if (header?.company_id) {
        payload.companyId = String(header.company_id);
      }
      if (appTransactionId !== undefined && appTransactionId !== null && String(appTransactionId).trim() !== '') {
        payload.appTransactionId = String(appTransactionId);
      }
      return payload;
    } catch (e) {
      console.warn('[Payment Form] Failed to build Stripe intent payload', e);
      return null;
    }
  }

  getStripeTransactionStatusLabel(): string {
    const normalized = this.normalizeStripeStatus(this.vm?.item?.header?.stripe_status);
    if (!normalized) {
      return 'Not processed';
    }

    if (normalized === 'succeeded') {
      return 'Succeeded';
    }

    if (normalized === 'processing') {
      return 'Processing';
    }

    if (normalized === 'requires_action') {
      return 'Requires action';
    }

    if (normalized === 'requires_payment_method') {
      return 'Requires payment method';
    }

    if (normalized === 'canceled') {
      return 'Canceled';
    }

    return normalized.replace(/_/g, ' ');
  }

  getStripeTransactionStatusClass(): string {
    const normalized = this.normalizeStripeStatus(this.vm?.item?.header?.stripe_status);
    // AP Connect: use isCancellable + status for badge color
    if (this.getCurrentFlow() === 'AP' && this.isSavedStripePayment()) {
      const apStatus = String(this.vm?.item?.header?.stripe_status || '').toLowerCase();
      if (apStatus === 'succeeded') {
        return 'bg-light text-success border-success';
      }
      if (apStatus === 'canceled' || apStatus === 'cancelled' || apStatus === 'failed') {
        return 'bg-light text-muted border-secondary';
      }
      if (this.stripeApIsCancellable) {
        return 'bg-light text-warning border-warning';
      }
      return 'bg-light text-warning border-warning';
    }
    if (normalized === 'succeeded') {
      return 'bg-light text-success border-success';
    }

    return 'bg-light text-warning border-warning';
  }

  getStripeTransactionStatusMessage(): string {
    // const statusUtc =  this.vm?.item?.header?.stripe_last_status_utc;
    // Display in LOCAL time (browser/host locale). Keep storage in UTC/ISO upstream.
    // Using Angular's formatDate without a timezone argument formats in local time.
    const statusUtc = formatDate(
      this.vm?.item?.header?.stripe_last_status_utc,
      'medium',
      'en-US'
    );
    //console.log('statusUtc', this.vm?.item?.header?.stripe_last_status_utc);
    // console.log('vm.item', this.vm.item);
    if (!statusUtc) {
      return 'No Stripe Status Updates.';
    }

    return `Stripe Updated: ${statusUtc}`;
  }

  canCancelStripePayment(): boolean {
    if (!this.isStripePaymentTypeUiSelected() || this.stripeCancelLoading) {
      return false;
    }

    const paymentIntentId = this.resolveStripePaymentIntentIdForCancel();
    if (!paymentIntentId) {
      return false;
    }

    const status = this.normalizeStripeStatus(this.vm?.item?.header?.stripe_status);
    return status !== 'succeeded' && status !== 'canceled';
  }

  private shouldBlockDeleteUntilStripeCanceled(): boolean {
    const header = this.vm?.item?.header;
    if (!header) {
      return false;
    }

    if (!this.isSavedStripePayment()) {
      return false;
    }

    // AP Connect payments are handled separately via transfer reversal — never block here
    if (this.getCurrentFlow() === 'AP') {
      return false;
    }

    const hasStripeContext = Boolean(
      header?.stripe_payment_intent_id ||
      header?.stripe_payment_method_id ||
      header?.stripe_transaction_id ||
      String(header?.number || '').trim().toLowerCase().startsWith('pi_')
    );

    if (!hasStripeContext) {
      return true;
    }

    const status = this.normalizeStripeStatus(header?.stripe_status);
    return status !== 'canceled';
  }

  // ── STRIPE: cancel execution (called from deleteItem delete-after-cancel path) ──
  private async executeStripeCancelPayment(deleteAfterCancel = true): Promise<void> {
    if (!this.canCancelStripePayment()) {
      const header = this.vm?.item?.header;
      const status = this.normalizeStripeStatus(header?.stripe_status);
      const resolvedIntentId = this.resolveStripePaymentIntentIdForCancel();
      if (!resolvedIntentId) {
        this.notification.showWarningToast('No Stripe payment intent found to cancel.');
      } else if (status === 'succeeded' || status === 'canceled') {
        this.notification.showWarningToast('This Stripe payment cannot be canceled from its current status.');
      }
      return;
    }

    const header = this.vm?.item?.header || {};
    const appEntityId = String(header?.entity_id || '').trim();
    const paymentIntentId = this.resolveStripePaymentIntentIdForCancel();

    if (!appEntityId || !paymentIntentId) {
      this.notification.showWarningToast('Stripe payment intent is missing required information to cancel.');
      return;
    }

    this.stripeCancelLoading = true;
    try {
      const cancelResult: any = await lastValueFrom(this.stripePaymentService.cancelPaymentIntent(
        paymentIntentId,
        appEntityId
      ));
      const cancelStatus = this.extractStripeStatus(cancelResult);
      if (cancelStatus !== 'canceled') {
        this.notification.showWarningToast('Stripe cancellation is not confirmed yet. Payment was not deleted.');
        return;
      }

      this.vm.item.header.stripe_status = 'canceled';
      this.vm.item.header.stripe_last_status_utc = new Date().toISOString();
      if (deleteAfterCancel) {
        this.notification.showSuccessToast('Stripe payment canceled. Deleting payment...');
        this.deleteItemByArray();
      } else {
        this.notification.showSuccessToast('Stripe payment canceled.');
        this.clearPaymentDataAfterStripeCancel();
      }
    } catch (error: any) {
      const apiError = error?.error?.Message || error?.error?.message || error?.message
        || 'Stripe cancellation failed. Payment was not deleted.';
      this.notification.showErrorToast(apiError);
    } finally {
      this.stripeCancelLoading = false;
    }
  }

  private clearPaymentDataAfterStripeCancel(): void {
    const header = this.vm?.item?.header;
    if (!header) {
      return;
    }

    header.payment_type_id = '';
    header.number = '';
    header.detail_total = 0;

    if (Array.isArray(this.vm?.item?.detail) && this.vm.item.detail.length > 0) {
      for (const d of this.vm.item.detail) {
        d.amount = 0;
        if (Object.prototype.hasOwnProperty.call(d, 'debit_credit')) {
          d.debit_credit = 0;
        }
      }
    }

    this.vm.applied = [];
    this.vm.item.applied = [];

    if (Array.isArray(this.vm?.invoices)) {
      for (const invoice of this.vm.invoices) {
        invoice.applied_amount = '';
      }
    }

    this.vm.totalPaid = 0;
    this.vm.totalOwing = 0;
    this.vm.totalBalance = 0;
    this.vm.manualAmount = false;
    this.calcTotals();
  }

  private resolveStripePaymentIntentIdForCancel(): string | null {
    const header = this.vm?.item?.header;
    if (!header) {
      return null;
    }

    const directIntentId = String(header?.stripe_payment_intent_id || '').trim();
    if (directIntentId) {
      return directIntentId;
    }

    const numberValue = String(header?.number || '').trim();
    if (numberValue.toLowerCase().startsWith('pi_')) {
      return numberValue;
    }

    return null;
  }

  private async ensureStripeMethodReadiness(): Promise<boolean> {
    const paymentType = this.getSelectedPaymentTypeConfig();
    const requiresVerifiedMethod = Boolean(
      this.getPaymentTypeFlag(paymentType, 'stripe_requires_verified_method', 'stripeRequiresVerifiedMethod')
    );

    if (this.vm?.item?.header?.stripe_payment_method_id) {
      this.setStripeSetupStatus('verified', 'Stripe ACH setup is verified and ready.');
      return true;
    }

    const header = this.vm?.item?.header || {};
    const appEntityId = String(header?.entity_id || '').trim();
    const stripeFlowType = this.resolveStripeEntityTypeCodeForPayment();

    if (!appEntityId) {
      this.notification.showWarningToast('Select an entity before Stripe payment can continue.');
      return false;
    }

    try {
      const methods = await lastValueFrom(this.stripePaymentService.getPaymentMethods(appEntityId, stripeFlowType));
      const paymentMethodId = this.resolveStripePaymentMethodIdFromResponse(methods as any[]);
      const pendingSetupCount = this.extractPendingSetupCount(methods as any[]);

      if (paymentMethodId) {
        this.vm.item.header.stripe_payment_method_id = paymentMethodId;
        this.setStripeSetupStatus('verified', 'Stripe ACH setup is verified and ready.');
        return Boolean(this.vm.item.header.stripe_payment_method_id);
      }

      if (pendingSetupCount > 0) {
        this.setStripeSetupStatus('pending', 'Stripe ACH setup is pending verification. Complete verification in Stripe Admin.');
      } else {
        this.setStripeSetupStatus('pending', 'No Stripe ACH payment method is available for this entity. Complete setup in Stripe Admin.');
      }

      this.notification.showWarningToast('No Stripe ACH payment method is available for this entity. Complete ACH setup in Stripe Admin, then retry save.');
      return false;
    } catch (error: any) {
      this.setStripeSetupStatus('pending', 'Unable to verify Stripe ACH setup status right now.');
      const apiError = error?.error?.Message || error?.error?.message || error?.message || 'Unable to verify Stripe payment method.';
      this.notification.showErrorToast(apiError);
      return false;
    }
  }

  private normalizeStripeStatus(status: any): string {
    return String(status || '').trim().toLowerCase();
  }

  private isStripeSuccessStatus(status: string): boolean {
    const normalized = this.normalizeStripeStatus(status);
    return normalized === 'succeeded' || normalized === 'complete';
  }

  private isStripeFailureStatus(status: string): boolean {
    const normalized = this.normalizeStripeStatus(status);
    return normalized === 'canceled' || normalized === 'requires_payment_method' || normalized === 'requires_action';
  }

  private isStripePendingStatus(status: string): boolean {
    const normalized = this.normalizeStripeStatus(status);
    return normalized === 'processing'
      || normalized === 'pending'
      || normalized === 'requires_confirmation'
      || normalized === 'requires_capture'
      || normalized === 'in_progress';
  }

  private isStripeAcceptedForAppSave(status: string): boolean {
    return this.isStripeSuccessStatus(status) || this.isStripePendingStatus(status);
  }


  private extractStripeStatus(payload: any): string {
    if (!payload) {
      return '';
    }

    const statusRaw =
      payload?.status ||
      payload?.Status ||
      payload?.paymentStatus ||
      payload?.StripeStatus ||
      payload?.payment_status ||
      payload?.stripe_status ||
      payload?.PaymentStatus ||
      payload?.paymentIntentStatus ||
      payload?.payment_intent_status ||
      payload?.intent_status ||
      payload?.paymentIntent?.status ||
      payload?.payment_intent?.status ||
      payload?.intent?.status ||
      payload?.data?.status ||
      payload?.data?.Status ||
      payload?.Data?.status ||
      payload?.Data?.Status ||
      payload?.data?.paymentStatus ||
      payload?.Data?.paymentStatus ||
      payload?.data?.PaymentStatus ||
      payload?.Data?.PaymentStatus ||
      payload?.data?.payment_status ||
      payload?.Data?.payment_status ||
      payload?.data?.stripeStatus ||
      payload?.Data?.StripeStatus ||
      payload?.data?.paymentIntent?.status ||
      payload?.Data?.paymentIntent?.status ||
      payload?.data?.payment_intent?.status ||
      payload?.Data?.payment_intent?.status ||
      payload?.data?.intent?.status ||
      payload?.Data?.intent?.status;

    return this.normalizeStripeStatus(statusRaw);
  }

  private extractStripeRejectionReason(payload: any): string {
    if (!payload) {
      return '';
    }

    const directReason =
      payload?.reason ||
      payload?.failure_reason ||
      payload?.failureReason ||
      payload?.decline_reason ||
      payload?.declineReason ||
      payload?.decline_code ||
      payload?.declineCode ||
      payload?.message ||
      payload?.Message ||
      payload?.error ||
      payload?.Error ||
      payload?.error_description ||
      payload?.errorDescription ||
      payload?.last_payment_error?.message ||
      payload?.lastPaymentError?.message ||
      payload?.last_payment_error?.decline_code ||
      payload?.lastPaymentError?.declineCode ||
      payload?.last_payment_error?.code ||
      payload?.lastPaymentError?.code ||
      payload?.paymentIntent?.last_payment_error?.message ||
      payload?.paymentIntent?.last_payment_error?.decline_code ||
      payload?.paymentIntent?.last_payment_error?.code ||
      payload?.payment_intent?.last_payment_error?.message ||
      payload?.payment_intent?.last_payment_error?.decline_code ||
      payload?.payment_intent?.last_payment_error?.code;

    if (directReason) {
      return String(directReason).trim();
    }

    const nestedReason =
      payload?.data?.reason ||
      payload?.Data?.reason ||
      payload?.data?.message ||
      payload?.Data?.Message ||
      payload?.error?.message ||
      payload?.error?.Message ||
      payload?.error?.reason ||
      payload?.error?.Reason ||
      payload?.data?.last_payment_error?.message ||
      payload?.Data?.last_payment_error?.message ||
      payload?.data?.paymentIntent?.last_payment_error?.message ||
      payload?.Data?.paymentIntent?.last_payment_error?.message ||
      payload?.data?.payment_intent?.last_payment_error?.message ||
      payload?.Data?.payment_intent?.last_payment_error?.message;

    return nestedReason ? String(nestedReason).trim() : '';
  }

  private formatStripeStatusLabel(status: string): string {
    const normalized = this.normalizeStripeStatus(status);
    return normalized ? normalized.replace(/_/g, ' ') : 'unknown';
  }

  private buildStripeRejectedSaveMessage(status: string, payload?: any): string {
    const reason = this.extractStripeRejectionReason(payload);
    const statusLabel = this.formatStripeStatusLabel(status);
    if (reason) {
      return `Stripe rejected save of payment. Reason: ${reason}`;
    }

    return `Stripe rejected save of payment. Reason: payment status is ${statusLabel}.`;
  }

  private setStripeSaveProcessing(isProcessing: boolean): void {
    this.stripeSaveProcessing = isProcessing;
  }

  private logPaymentSave(step: string, details: any): void {
    try {
      // Lightweight debug logger for save pipeline tracing
      // Intentionally uses console.log for immediate visibility during troubleshooting
      // Disable or refine as needed once the issue is resolved
      // eslint-disable-next-line no-console
      console.log(`[Payment Form][SaveTrace] ${step}`, details);
    } catch {
      // no-op
    }
  }

  // Removed legacy helper: Stripe flow now handled in a single pre-save path

  private ensureStripeHeaderPayloadFields(): void {
    if (!this.isStripePaymentTypeSelected()) {
      return;
    }

    const header = this.vm?.item?.header;
    if (!header) {
      return;
    }

    // header.stripe_customer_id = header.stripe_customer_id ?? null;
    // header.stripe_payment_method_id = header.stripe_payment_method_id ?? null;
    header.stripe_payment_intent_id = header.stripe_payment_intent_id ?? null;
    //header.stripe_transaction_id = header.stripe_transaction_id ?? null;
    // header.stripe_status = header.stripe_status ?? null;
    // header.stripe_last_status_utc = header.stripe_last_status_utc ?? null;
  }

  // ---- Stripe status refresh (Payment Form) ----
  private stripeStatusRefreshLoading = false;

  private getCurrentPaymentIntentId(): string {
    const header = this.vm?.item?.header || {};
    const explicit = String(header?.stripe_payment_intent_id || '').trim();
    if (explicit) {
      return explicit;
    }
    const num = String(header?.number || '').trim();
    return num.toLowerCase().startsWith('pi_') ? num : '';
  }

  canRefreshStripeStatus(): boolean {
    if (!this.isStripePaymentTypeUiSelected()) {
      return false;
    }
    if (this.vm.subLedger === SUBLEDGER_AP) {
      return false;
    }
    const pi = this.getCurrentPaymentIntentId();
    return Boolean(pi);
  }

  onRefreshStripeStatusCurrentPayment(): void {
    if (!this.canRefreshStripeStatus() || this.stripeStatusRefreshLoading) {
      return;
    }
    const pi = this.getCurrentPaymentIntentId();
    if (!pi) {
      this.notification.showWarningToast('No Stripe Payment Intent to refresh.');
      return;
    }
    this.stripeStatusRefreshLoading = true;
    this.stripePaymentService.getPaymentStatus(pi).subscribe({
      next: (res: any) => {
        const status = res?.Status || res?.status || '';
        const updated = res?.UpdatedUtc || res?.updatedUtc || new Date().toISOString();
        if (status) {
          this.vm.item.header.stripe_status = status;
        }
        this.vm.item.header.stripe_last_status_utc = updated;
        this.notification.showSuccessToast('Stripe status refreshed.');
      },
      error: (err: any) => {
        const msg = err?.error?.Message || err?.message || 'Failed to refresh Stripe status.';
        this.notification.showWarningToast(msg);
      },
      complete: () => {
        this.stripeStatusRefreshLoading = false;
      }
    });
  }

  // ── SAVE PIPELINE ────────────────────────────────────────────────────────
  // save() is the single public entry point.
  // It delegates to three focused helpers in sequence:
  //   1. validateSaveInputs()   — all field/date/entity validation
  //   2. handleStripePreSave()  — Stripe intent creation for new AR payments
  //   3. persistPayment()       — POST (new) or PATCH (edit) to the API
  // ─────────────────────────────────────────────────────────────────────────

  async save(): Promise<void> {
    // Gate: Stripe flow verification
    if (this.isStripePaymentTypeSelected()) {
      const ok = await this.ensureStripeVerifiedForCurrentFlow();
      if (!ok) {
        return;
      }
    }

    if (this.vm.noBillToError) {
      this.notification.showWarningToast('Cannot save using Entity with no Bill To address');
      return;
    }

    this.submitted = true;
    this.vm.buttonsDisabled = true;
    this.vm.errorDescription = '';
    this.vm.alert = {};

    // Step 1 — validate
    if (!this.validateSaveInputs()) {
      this.notification.showWarningToast('Form Errors!');
      this.vm.buttonsDisabled = false;
      return;
    }

    // Step 2 — normalize for save
    this.preparePaymentForSave();

    // Step 2a — AP only: require at least one applied invoice
    if (this.isApMode()) {
      if (!this.hasAnyApplied()) {
        this.notification.showWarningToast('At least one invoice must be applied before saving an AP payment.');
        this.vm.buttonsDisabled = false;
        return;
      }

      // Step 2b — AP only: check for short-paid invoices
      const shortPayOk = await this.checkShortPaidInvoices();
      if (!shortPayOk) {
        this.vm.buttonsDisabled = false;
        return;
      }
    }

    // Step 3 — invoice conflict check
    const invoicesOk = await this.getInvoicesStillNotPaid();
    if (!invoicesOk) {
      this.vm.buttonsDisabled = false;
      return;
    }

    // Step 4 — Stripe pre-save (new AR payments only)
    this.ensureStripeHeaderPayloadFields();
    const stripeOk = await this.handleStripePreSave();
    if (!stripeOk) {
      this.vm.buttonsDisabled = false;
      return;
    }

    // Step 5 — payment number gate (non-Stripe, non-check types require a number)
    const paymentNumber = String(this.vm?.item?.header?.number ?? '').trim();
    if (!paymentNumber && !this.isStripePaymentTypeSelected() && !this.isPaymentTypeCheck()) {
      this.notification.showErrorToast($localize`:Payment Number is required@@paymentNumberRequired:Payment Number is required.`);
      this.vm.buttonsDisabled = false;
      return;
    }

    // Step 6 — persist
    this.buildApplied();
    const isNewForLog = !this.vm?.item?.header?.id;
    console.log('[PaymentForm][PreSave]', isNewForLog ? 'POST' : 'PATCH',
      'batch.type_id:', this.vm?.item?.batch?.type_id,
      'detail_total:', this.vm?.item?.header?.detail_total,
      'debit_credit:', this.vm?.item?.detail?.[0]?.debit_credit,
      'amount:', this.vm?.item?.detail?.[0]?.amount,
      'applied:', JSON.stringify((this.vm?.item?.applied || []).map((r: any) => ({id: r.applied_header_id, amt: r.applied_amount}))));
    await this.persistPayment();
  }

  // AP only: checks for invoices where applied_amount < full balance (short pay).
  // If found, prompts user to create a credit memo. Returns true to continue save, false to abort.
  private checkShortPaidInvoices(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const allRows = [...(this.vm?.applied || []), ...(this.vm?.invoices || [])];
      const shortPaid = allRows.filter((row: any) => {
        const applied = Math.abs(Number(row?.applied_amount || 0));
        if (applied <= 0) {
          return false;
        }
        const balance = this.getRowBalance(row);
        return balance > 0.005; // invoice still has remaining balance after this payment
      });

      if (shortPaid.length === 0) {
        resolve(true);
        return;
      }

      const names = shortPaid.map((r: any) => r.number || r.invoice_number || r.applied_header_id || '').filter(Boolean).join(', ');
      this.confirmDialogService.confirmThis(
        [
          `${shortPaid.length} invoice(s) are short-paid: ${names}.`,
          'Would you like to create a credit memo for the remaining balance?',
          'danger:If No, the save will be cancelled — fully pay or create a credit memo to proceed.'
        ],
        () => {
          // User chose to create credit memos — call api/entry/credit-memo for each short-paid invoice
          this.createCreditMemosForShortPaid(shortPaid).then((ok) => resolve(ok));
        },
        () => {
          // User declined credit memo — block save
          this.notification.showWarningToast('Save cancelled. Please fully apply all invoices or create a credit memo for the remaining balance.');
          resolve(false);
        }
      );
    });
  }

  private async createCreditMemosForShortPaid(shortPaidRows: any[]): Promise<boolean> {
    try {
      const header = this.vm?.item?.header;
      for (const row of shortPaidRows) {
        const remainingBalance = this.getRowBalance(row);
        const invoiceId = row.applied_header_id || row.id;
        // Get expense account_id from the invoice record in vm.invoices
        const invoice = (this.vm?.invoices || []).find((inv: any) =>
          inv.id === invoiceId || inv.applied_header_id === invoiceId
        );
        const accountId = invoice?.account_id || row?.account_id || null;
        const creditMemoPayload = {
          entity_id: header?.entity_id,
          company_id: header?.company_id,
          account_id: accountId,
          number: `CM-${row.number || row.invoice_number || invoiceId}`,
          header_date: header?.header_date || new Date().toISOString(),
          detail_total: remainingBalance,
          memo: `Credit for short-paid invoice ${row.number || row.invoice_number || ''}`.trim(),
          applied: [
            {
              applied_header_id: invoiceId,
              applied_amount: remainingBalance
            }
          ]
        };
        await lastValueFrom(this.tableDataService.post('entry/credit-invoice', creditMemoPayload));
      }
      this.notification.showSuccessToast('Credit memo(s) created and applied to short-paid invoice(s).');
      return true;
    } catch (err: any) {
      const msg = err?.error?.Message || err?.error?.message || err?.message || 'Failed to create credit memo(s).';
      this.notification.showErrorToast(msg);
      return false;
    }
  }

  // Validates all required fields. Sets vm error flags for template highlighting.
  // Returns true if valid, false if any error found.
  private validateSaveInputs(): boolean {
    let valid = true;

    if (!this.vm.item.header.header_date) {
      this.vm.dateMissing = true;
      valid = false;
      if (!this.vm.item.header.company_id) {
        this.vm.companyError = true;
      }
    } else {
      const company = this.FilterObject(this.vm.company, {id: this.vm.item.header.company_id}, true)[0];
      let yearEndDate = company?.year_end_date;
      let cutOffDate = company?.cut_off_date;
      const headerDate = new Date(this.vm.item.header.header_date);
      if (headerDate < new Date(yearEndDate)) {
        yearEndDate = this.dateFilter.GetDateFormat(yearEndDate);
        this.notification.showWarningToast(
          $localize`:Date must be greater than the year end @@datemustbegreaterthantheyearend:Date must be greater than the year end` + ' ' + yearEndDate
        );
        valid = false;
      }
      if (headerDate < new Date(cutOffDate)) {
        cutOffDate = this.dateFilter.GetDateFormat(cutOffDate);
        this.notification.showWarningToast(
          $localize`:Date must be greater than the cut off date @@datemustbegreaterthanthecutoffdate:Date must be greater than the cut off date` + ' ' + cutOffDate
        );
        valid = false;
      }
      this.vm.item.header.header_date = this.dateFilter.GetDateFormat(this.vm.item.header.header_date);
    }

    if (!this.vm.item.header.currency_id) {
      this.vm.currencyError = true;
    }
    if (!this.vm.item.header.bank_id) {
      this.vm.bankError = true;
      valid = false;
    }
    if (!this.vm.item.header.payment_type_id) {
      this.vm.paymentTypeError = true;
      valid = false;
    }
    if (this.vm.entityError === true) {
      valid = false;
    }

    if (
      !this.vm.item.header.description ||
      !this.vm.item.header.entityInput ||
      !this.vm.item.header.company_id ||
      !this.vm.item.header.header_date ||
      !this.vm.item.header.payment_type_id ||
      !this.vm.item.header.bank_id
    ) {
      valid = false;
    }

    return valid;
  }

  // Handles Stripe intent creation for new AR payments before the app record is saved.
  // AP Stripe payments are handled by Issue Payments — only sets stripe_status = 'pending' here.
  // Returns true to continue save, false to abort.
  private async handleStripePreSave(): Promise<boolean> {
    const isStripe = this.isStripePaymentTypeSelected();
    const isNew = !this.vm?.item?.header?.id;
    if (!isStripe || !this.isStripeAllowedForCurrentFlow() || !isNew) {
      return true;
    }

    try {
      const flow = this.getCurrentFlow();
      if (flow === 'AP') {
        this.vm.item.header.stripe_status = 'pending';
        return true;
      }

      // AR: create payment intent pre-save
      const prePayload = this.buildStripeIntentPayload(null);
      if (!prePayload) {
        return true;
      }
      if (this.vm?.item?.header?.number) {
        prePayload.referenceId = String(this.vm.item.header.number);
      }
      this.logPaymentSave('Step 1 - Stripe intent request (pre-save new)', {
        method: 'POST',
        url: '/api/stripe/payments/intent',
        payload: prePayload
      });
      const intentPre: any = await lastValueFrom(this.stripePaymentService.createPaymentIntent(prePayload));
      this.logPaymentSave('Step 2 - Stripe intent response (pre-save new)', {
        method: 'POST',
        url: '/api/stripe/payments/intent',
        response: intentPre
      });

      const res0 = intentPre?.Result || intentPre?.result || null;
      const resLegacy = (intentPre?.Data?.[0] || intentPre?.data?.[0])?.Result || null;
      const paymentIntentId = res0?.PaymentIntentId || res0?.paymentIntentId
        || resLegacy?.PaymentIntentId || resLegacy?.paymentIntentId
        || intentPre?.PaymentIntentId || intentPre?.paymentIntentId || intentPre?.id || null;
      const status = res0?.Status || res0?.status || resLegacy?.Status || resLegacy?.status || intentPre?.status || null;

      if (paymentIntentId) {
        this.vm.item.header.stripe_payment_intent_id = paymentIntentId;
        this.vm.item.header.stripe_status = status || this.vm.item.header.stripe_status;
        this.vm.item.header.stripe_last_status_utc = new Date().toUTCString();
      }
      return true;
    } catch (e: any) {
      const isApFlow = this.getCurrentFlow() === 'AP';
      const statusCode = (e?.status ?? e?.StatusCode ?? e?.error?.StatusCode ?? e?.error?.status) as number | undefined;
      this.logPaymentSave('Step 2 - Stripe intent error (pre-save new)', {
        method: 'POST',
        url: isApFlow ? '/api/stripe/rails/ap/push/intent' : '/api/stripe/payments/intent',
        error: e
      });
      if (isApFlow && statusCode === 401) {
        return false;
      }
      this.notification.showErrorToast('Stripe payment could not be started. Please try again or complete setup.');
      return false;
    }
  }

  // Persists the payment via POST (new) or PATCH (edit).
  // Uses async/await throughout — no mixed subscribe/then callbacks.
  private async persistPayment(): Promise<void> {
    const isNew = this.vm.item.header.id === undefined;

    if (isNew) {
      // POST — new payment
      this.logPaymentSave('Step 3 - App payment save request (new)', {method: 'POST', url: 'entry', payload: this.vm.item});
      try {
        const result: any = await lastValueFrom(this.tableDataService.post('entry', this.vm.item));
        this.logPaymentSave('Step 4 - App payment save response (new)', {method: 'POST', url: 'entry', response: result});
        this.vm.buttonsDisabled = false;
        this.vm.invoices = [];
        this.vm.applied = [];
        this.vm.item.header.id = result.id;
        this.paymentId = result.id;
        this.originalDocument = structuredClone(this.buildSnapshot());
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {paymentId: result.id},
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
        if (this.vm.action === 'new') {
          this.vm.action = '';
          const route = this.vm.subLedger === 'ap' ? '/transactions/payment/form?paymentId=newAp' : '/transactions/payment/form?paymentId=newAr';
          this.router.navigateByUrl(route).then();
        }
      } catch (error2: any) {
        this.logPaymentSave('Step 4 - App payment save error (new)', {method: 'POST', url: 'entry', error: error2});
        this.vm.buttonsDisabled = false;
        const apiErr = error2?.error || {};
        const msg = apiErr.Message || apiErr.message || error2?.message || error2?.statusText || 'Save failed due to a server error.';
        this.notification.showErrorToast(String(msg));
      }
    } else {
      // PATCH — edit existing payment
      const changes: any = {detail: this.vm.item.detail, applied: this.vm.item.applied};
      const headerChanges: any = {};
      for (const key in this.vm.item.header) {
        if (Object.prototype.hasOwnProperty.call(this.vm.item.header, key) && key !== 'entityInput') {
          headerChanges[key] = this.vm.item.header[key];
        }
      }
      changes.header = headerChanges;
      this.vm.changes = changes;

      const appSaveUrl = `entry/${this.vm.item.header.id}`;
      this.logPaymentSave('Step 3 - App payment save request (edit)', {method: 'PATCH', url: appSaveUrl, payload: changes});
      try {
        const item: any = await this.tableDataService.patch('entry', this.vm.item.header.id, changes);
        this.logPaymentSave('Step 4 - App payment save response (edit)', {method: 'PATCH', url: appSaveUrl, response: item});
        this.vm.buttonsDisabled = false;
        this.originalDocument = structuredClone(this.buildSnapshot());
        if (item.description === 'Deleted') {
          this.router.navigateByUrl('/transactions/payment/list/' + this.vm.subLedger + 'type=ap&subLedger=ap').then();
        } else if (this.vm.action === 'new') {
          this.vm.action = '';
          const route = this.vm.subLedger === 'ap'
            ? '/transactions/payment/form?paymentId=newAP&&batchId='
            : '/transactions/payment/form?paymentId=newAR&batchId=';
          this.router.navigateByUrl(route).then();
        }
      } catch (msg: any) {
        this.logPaymentSave('Step 4 - App payment save error (edit)', {method: 'PATCH', url: appSaveUrl, error: msg});
        this.vm.buttonsDisabled = false;
        const apiErr = msg?.error || {};
        const errMsg = apiErr.Message || apiErr.message || msg?.message || msg?.statusText || 'Save failed due to a server error.';
        this.notification.showErrorToast(String(errMsg));
      }
    }
  }

  saveNew() {
    this.vm.action = 'new';
    this.save().then();
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  OrderBy(array, field, reverse = true) {
    return new ArraySortPipe().transform(array, field, reverse);
  }

  deleteItem() {
    const header = this.vm?.item?.header;

    // Block delete if payment has been printed or issued
    if (header?.printed || header?.payment_issued) {
      this.notification.showWarningToast('This payment has been printed or issued and cannot be deleted.');
      return;
    }

    // AP Connect Transfer: reverse before delete if cancellable
    if (this.getCurrentFlow() === 'AP' && this.isSavedStripePayment() && this.stripeApIsCancellable && this.stripeApTransferId) {
      void this.executeApTransferReverseAndDelete();
      return;
    }

    const paymentIntentId = this.resolveStripePaymentIntentIdForCancel();
    const normalizedStatus = this.normalizeStripeStatus(header?.stripe_status);
    const blockDeleteUntilCanceled = this.shouldBlockDeleteUntilStripeCanceled();
    const cancelable = this.canCancelStripePayment();

    if (blockDeleteUntilCanceled) {
      if (cancelable) {
        void this.executeStripeCancelPayment(true);
      } else {
        // Diagnostic log: explain why Stripe cancel cannot proceed
        try {
          const header = this.vm?.item?.header || {};
          const isStripeUi = this.isStripePaymentTypeUiSelected();
          const loading = this.stripeCancelLoading;
          const intentId = this.resolveStripePaymentIntentIdForCancel();
          const status = this.normalizeStripeStatus(header?.stripe_status);
          console.log('[Payment Form][Stripe delete guard] Blocked because Stripe cancel preconditions failed', {
            isStripeUiSelected: isStripeUi,
            stripeCancelLoading: loading,
            resolvedPaymentIntentId: intentId,
            normalizedStripeStatus: status,
          });
        } catch {
        }
        this.notification.showWarningToast('Stripe cancel confirmation is required before deleting this payment.');
      }
      return;
    }

    const brClass = this;
    const messages: string[] = [
      $localize`:Are you sure you want to delete Payment? @@areyousureyouwanttodeletePayment:Are you sure you want to delete Payment?`,
      this.vm.item.header.number,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.vm.item.header.deleted = true;
        // this.save();
        this.deleteItemByArray();
      },
      () => {
        brClass.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  private executeApTransferReverseAndDelete(): void {
    const appEntityId = String(this.vm?.item?.header?.entity_id || '').trim();
    const messages: string[] = [
      $localize`:Are you sure you want to delete Payment? @@areyousureyouwanttodeletePayment:Are you sure you want to delete Payment?`,
      this.vm.item.header.number,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      async () => {
        try {
          const req: ReverseApTransferRequest = {
            appEntityId,
            transferId: this.stripeApTransferId,
            reason: 'Cancelled by user',
          };
          const result = await lastValueFrom(this.stripeApService.reverseTransfer(req));
          if (result?.blocked) {
            this.notification.showErrorToast(result.message || 'Transfer cannot be reversed. Payment not deleted.');
            return;
          }
          if (result?.reversed) {
            this.stripeApIsCancellable = false;
            this.vm.item.header.stripe_status = result.status || 'Canceled';
          }
        } catch (e: any) {
          const msg = e?.error?.Message || e?.error?.message || e?.message || 'Stripe cancellation failed. Payment not deleted.';
          this.notification.showErrorToast(msg);
          return;
        }
        // Stripe reversal succeeded — proceed to delete
        this.vm.item.header.deleted = true;
        this.deleteItemByArray();
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  async loadApStripeTransactionStatus(): Promise<void> {
    const header = this.vm?.item?.header;
    const transferId = String(header?.stripe_payment_intent_id || '').trim();
    const entityId = String(header?.entity_id || '').trim();
    if (!transferId || !entityId || !transferId.startsWith('tr_')) {
      return;
    }
    try {
      const toDate = new Date();
      const fromDate = new Date();
      fromDate.setFullYear(fromDate.getFullYear() - 2);
      const from = fromDate.toISOString().split('T')[0];
      const to = toDate.toISOString().split('T')[0];
      const result = await lastValueFrom(this.stripePaymentService.getAllPaymentsByEntity(entityId, 1, 50, from, to));
      const rows: any[] = Array.isArray(result) ? result : (result?.data || result?.Data || []);
      const match = rows.find((r: any) =>
        (r.stripeTransferId || r.StripeTransferId || '') === transferId
      );
      if (match) {
        this.stripeApIsCancellable = !!(match.isCancellable ?? match.IsCancellable);
        this.stripeApTransferId = transferId;
        const status = match.status || match.Status || match.lifecycleStage || match.LifecycleStage || '';
        if (status) {
          this.vm.item.header.stripe_status = status;
        }
      }
    } catch {
      // Non-fatal: status badge will fall back to stored stripe_status
    }
  }

  voidPayment() {
    const header = this.vm?.item?.header;
    if (!header?.id) {
      return;
    }
    if (!header?.printed) {
      this.notification.showWarningToast('Only printed checks can be voided.');
      return;
    }
    this.confirmDialogService.confirmThis(
      [
        `Void Check #${header.number} for ${header.entity_name || header.entityInput}?`,
        `Amount: ${header.detail_total}`,
        'danger: This action cannot be undone. The check will be permanently voided and all associated bills will be re-opened.',
      ],
      () => {
        this.vm.showVoidModal = true;
        this.vm.voidDate = this.dateFilter.GetDateFormat(new Date());
        this.vm.voidReason = '';
      },
      () => {
      }
    );
  }

  cancelVoid() {
    this.vm.showVoidModal = false;
    this.vm.voidDate = '';
    this.vm.voidReason = '';
  }

  confirmVoid() {
    const header = this.vm?.item?.header;
    if (!this.vm.voidDate || !this.vm.voidReason?.trim()) {
      this.notification.showWarningToast('Void Date and Reason are both required.');
      return;
    }
    const endpoint = `t_header/${header.id}/void`;
    const payload = {
      voidDate: this.vm.voidDate,
      reason: this.vm.voidReason.trim(),
    };
    console.log('[Void Payment] POST', endpoint, payload);
    this.tableDataService.post(endpoint, payload).subscribe({
      next: (result: any) => {
        console.log('[Void Payment] result', result);
        this.vm.showVoidModal = false;
        this.notification.showSuccessToast(`Check #${header.number} has been voided. The associated bill(s) have been re-opened.`);
        if (this.vm.subLedger === 'ap') {
          this.router.navigateByUrl('/transactions/payment/list/ap?type=ap&subLedger=ap').then();
        } else {
          this.router.navigateByUrl('/transactions/payment/list/ar?type=ar&subLedger=ar').then();
        }
      },
      error: (err: any) => {
        const code = err?.error?.code || err?.error?.Code || '';
        if (code === 'import_completed' || err?.status === 400) {
          const msg = err?.error?.message || err?.error?.Message || '';
          if (msg.toLowerCase().includes('reconcil')) {
            this.notification.showErrorToast('This payment cannot be voided — one or more lines have been included in a completed bank reconciliation.');
          } else {
            this.notification.showErrorToast(msg || 'Void failed. Please check the payment and try again.');
          }
        } else {
          this.notification.showErrorToast('Void failed. Please try again.');
        }
      }
    });
  }

  deleteItemByArray() {
    // just one item but stick it in array so api undertands - the old save as delete method above is not good - to slow.
    const header = this.vm?.item?.header || {};
    const deleteMe = [];
    deleteMe.push({
      header_id: header.id,
      entity_id: header.entity_id || null,
      company_id: header.company_id || null,
      location_id: header.location_id || null,
    });

    this.tableDataService.deleteDataByArray('entry', deleteMe).subscribe((item: any) => {
      if (item) {
        if (item.Message === 'Success') {
          if (this.vm.subLedger === 'ap') {
            this.router.navigateByUrl('/transactions/payment/list/ap?type=ap&subLedger=ap').then();
          } else {
            this.router.navigateByUrl('/transactions/payment/list/ar?type=ar&subLedger=ar').then();
          }
        }
      }
    });
  }

  saveClose() {
    this.save().then();
    this.onClose();
  }

  toggleBatches() {
    this.showBatches = !this.showBatches;
  }

  protected readonly String = String;
}
